import * as React from 'react'

const RobotIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={70}
    height={75}
    viewBox="0 0 70 74"
  >
    <defs>
      <clipPath id="bn">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="c">
        <path d="M69.305 10.156h.527v.434h-.527Zm0 0" />
      </clipPath>
      <clipPath id="b">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bq">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="e">
        <path d="M65.543 9.035h.242v.281h-.242Zm0 0" />
      </clipPath>
      <clipPath id="d">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bt">
        <path d="M67 19h2.832v3H67Zm0 0" />
      </clipPath>
      <clipPath id="bu">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="g">
        <path d="M62.11 11.535h.788v.703h-.789Zm0 0" />
      </clipPath>
      <clipPath id="f">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bx">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="i">
        <path d="M64.574 10.523h.39v.368h-.39Zm0 0" />
      </clipPath>
      <clipPath id="h">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bA">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="k">
        <path d="M62.434 10.152h.316v.48h-.316Zm0 0" />
      </clipPath>
      <clipPath id="j">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="m">
        <path d="M61.293 8.273h.797v.641h-.797Zm0 0" />
      </clipPath>
      <clipPath id="l">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="o">
        <path d="M67.082 17.906h.797v.64h-.797Zm0 0" />
      </clipPath>
      <clipPath id="n">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="q">
        <path d="M62.672 8.113h.305v.254h-.305Zm0 0" />
      </clipPath>
      <clipPath id="p">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bJ">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="s">
        <path d="M65.703 10.273h.309v.348h-.309Zm0 0" />
      </clipPath>
      <clipPath id="r">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bM">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="u">
        <path d="M26.508 50.09h.281v.37h-.281Zm0 0" />
      </clipPath>
      <clipPath id="t">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bP">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="w">
        <path d="M26.348 52.934h.199v.168h-.2Zm0 0" />
      </clipPath>
      <clipPath id="v">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bS">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="y">
        <path d="M28.543 54.418h.434v.562h-.434Zm0 0" />
      </clipPath>
      <clipPath id="x">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bV">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="A">
        <path d="M27.484 53.254h.266v.25h-.266Zm0 0" />
      </clipPath>
      <clipPath id="z">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bY">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="C">
        <path d="M27.566 54.723h.313v.254h-.313Zm0 0" />
      </clipPath>
      <clipPath id="B">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="E">
        <path d="M26.492 55.441h.375v.582h-.375Zm0 0" />
      </clipPath>
      <clipPath id="D">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="G">
        <path d="M32.078 50.172h.375v.582h-.375Zm0 0" />
      </clipPath>
      <clipPath id="F">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="I">
        <path d="M26.168 54.934h.18v.203h-.18Zm0 0" />
      </clipPath>
      <clipPath id="H">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="ch">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="K">
        <path d="M27.16 52.586h.211v.23h-.21Zm0 0" />
      </clipPath>
      <clipPath id="J">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="ck">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="M">
        <path d="M17.898 68.066h27.77V74h-27.77Zm0 0" />
      </clipPath>
      <clipPath id="N">
        <path d="M45.668 71.129c0 1.695-6.215 3.066-13.887 3.066-7.668 0-13.883-1.37-13.883-3.066 0-1.692 6.215-3.063 13.883-3.063 7.672 0 13.887 1.371 13.887 3.063" />
      </clipPath>
      <clipPath id="L">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="cn">
        <path d="M54 0h12v15H54Zm0 0" />
      </clipPath>
      <clipPath id="co">
        <path d="m54.809 11.848 3.406 2.777.355-1.938 4.68-.464.852-.375.992-11.02-.992-.422Zm0 0" />
      </clipPath>
      <clipPath id="cq">
        <path d="M21 54h9v13h-9Zm0 0" />
      </clipPath>
      <clipPath id="cr">
        <path d="M21.145 54.184c-.122.171.011 1.218.304 2.632.535 2.602 1.621 6.442 2.719 8.399.363.64.727 1.078 1.074 1.2 1.613.57 3.41-4.84 3.813-7.185.097-.332.113-.683.035-1.02-.363-.456-5.895-4.183-7.547-4.183a.45.45 0 0 0-.402.157" />
      </clipPath>
      <clipPath id="ct">
        <path d="M31 53h10v16H31Zm0 0" />
      </clipPath>
      <clipPath id="cu">
        <path d="M32.02 58.21a.73.73 0 0 0-.063.419c.066 1.637 1.898 7.133 3.523 8.941.2.25.461.442.762.555a.62.62 0 0 0 .207.031c.258-.008.52-.27.774-.726 1.074-1.903 2.066-7.125 2.55-10.684.032-.234.063-.46.09-.68.192-1.582.266-2.714.168-2.851a.15.15 0 0 0-.12-.043c-.981 0-7.016 3.863-7.891 5.039" />
      </clipPath>
      <clipPath id="cw">
        <path d="M21 53h9v6h-9Zm0 0" />
      </clipPath>
      <clipPath id="cx">
        <path d="M21.14 54.184c-.753.98 5.4 5.41 7.997 4.25 0 0-5.602-4.446-7.496-4.446a.594.594 0 0 0-.5.2" />
      </clipPath>
      <clipPath id="cz">
        <path d="M31 53h10v6H31Zm0 0" />
      </clipPath>
      <clipPath id="cA">
        <path d="M31.957 58.625c-.203.5 6.902-.645 8.07-5.41 0 0-6.144.715-8.07 5.41" />
      </clipPath>
      <clipPath id="cC">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="Q">
        <path d="M21.102 54.027h8.039v12.391H21.1Zm0 0" />
      </clipPath>
      <clipPath id="R">
        <path d="M23.836 58.297c-.348.422.078 5.906 1.406 8.121-.347-.125-.71-.563-1.074-1.203-.215-.961-.535-2.383-.84-3.805a17.293 17.293 0 0 0-1.879-4.59c-.293-1.418-.426-2.468-.308-2.636.718-1.055 7.543 3.52 7.949 4.027.074.34.062.691-.035 1.023 0 0-4.875-1.355-5.22-.937" />
      </clipPath>
      <clipPath id="P">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="cF">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="U">
        <path d="M31.953 53.172h8.121V67.57h-8.12Zm0 0" />
      </clipPath>
      <clipPath id="V">
        <path d="M39.86 56.066s-3.887 1.141-4.786 2.97c-.898 1.827-.562 6.167.406 8.53-1.625-1.808-3.46-7.3-3.523-8.937a.728.728 0 0 1 .059-.418c.93-1.25 7.636-5.504 8.011-4.996.102.137.028 1.27-.168 2.851" />
      </clipPath>
      <clipPath id="T">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="cI">
        <path d="M12 35h12v21H12Zm0 0" />
      </clipPath>
      <clipPath id="cJ">
        <path d="m20.023 38.379-.007.004c0 .004 0 .008-.004.008-.012.015-.024.03-.035.047a.105.105 0 0 1-.028.03l-.027.04c-.016.02-.035.043-.05.066a38.956 38.956 0 0 0-4.25 6.734 32.034 32.034 0 0 0-2.981 9.618c.355.105.714.18 1.082.23 1.078.157 2.77.203 4.183-.652l.004-.004c.07-.156 2.387-5.11 3.926-9.043.934-2.375 1.219-5.32 1.227-7.352.007-1.382-.122-2.347-.262-2.425a.108.108 0 0 0-.051-.012c-.316 0-1.402 1.047-2.727 2.71" />
      </clipPath>
      <clipPath id="cL">
        <path d="M12 52h6v4h-6Zm0 0" />
      </clipPath>
      <clipPath id="cM">
        <path d="M12.664 54.746a5.214 5.214 0 0 0 5.242-.246s.336-1.957-1.543-2.344a1.683 1.683 0 0 0-.343-.035c-1.75 0-3.356 2.629-3.356 2.629" />
      </clipPath>
      <clipPath id="cO">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="Y">
        <path d="M12.64 38.102h10.422v17.054H12.642Zm0 0" />
      </clipPath>
      <clipPath id="Z">
        <path d="M23.063 38.102c-.008 2.035-.293 4.976-1.227 7.351-1.54 3.938-3.856 8.89-3.926 9.047h-.004l-4.183.656a7.839 7.839 0 0 1-1.082-.23 32 32 0 0 1 2.98-9.617 38.807 38.807 0 0 1 4.23-6.711c-.788 1.03-4.09 5.523-4.976 9.343-1.012 4.344 3.066 2.672 4.734 0 1.664-2.671 3.403-9.84 3.403-9.84Zm0 0" />
      </clipPath>
      <clipPath id="X">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="cR">
        <path d="M12 53h7v12h-7Zm0 0" />
      </clipPath>
      <clipPath id="cS">
        <path d="M12.93 54.61c-.442.808-.668 5.476.441 9.331 0 0 1.57.418 2.746 0 1.176-.421 1.992-3.824 2.059-6.382.062-2.563-.817-4.246-2.418-4.504a1.58 1.58 0 0 0-.235-.02 3.5 3.5 0 0 0-2.593 1.574" />
      </clipPath>
      <clipPath id="cU">
        <path d="M15 54h4v11h-4Zm0 0" />
      </clipPath>
      <clipPath id="cV">
        <path d="M15.61 64.07c1.523-.293 2.074-1.914 2.433-5.086.36-3.175-.61-4.804-.61-4.804-3.253 1.68-1.82 9.89-1.82 9.89" />
      </clipPath>
      <clipPath id="cX">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="ac">
        <path d="M15.367 57.184h2.438v3.824h-2.438Zm0 0" />
      </clipPath>
      <clipPath id="ad">
        <path d="M15.379 59.512s.836 1.215 1.406 1.41c.332.121.692.117 1.02-.012l-2.117-3.726a9.575 9.575 0 0 0-.313 2.328" />
      </clipPath>
      <clipPath id="ab">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="da">
        <path d="M15 54h4v7h-4Zm0 0" />
      </clipPath>
      <clipPath id="db">
        <path d="M15.691 57.184c.2 1.152.563 2.27 1.079 3.32 1.011.941 1.73 0 1.73 0 .328-4.89-.96-6.149-.96-6.149-1.384.555-1.849 2.829-1.849 2.829" />
      </clipPath>
      <clipPath id="dd">
        <path d="M15 7h7v12h-7Zm0 0" />
      </clipPath>
      <clipPath id="de">
        <path d="M15.379 10.281c-.922 2.848.781 8.473.781 8.473l5.676-9.567s-2.129-1.82-4.734-2.136c0 0-.801.386-1.723 3.234" />
      </clipPath>
      <clipPath id="dg">
        <path d="M16 7h4v8h-4Zm0 0" />
      </clipPath>
      <clipPath id="dh">
        <path d="m16.09 8.469 2.453 5.863.617-.637c.082-4.687-2.058-6.644-2.058-6.644a4.298 4.298 0 0 0-1.016 1.418" />
      </clipPath>
      <clipPath id="dj">
        <path d="M39 7h8v12h-8Zm0 0" />
      </clipPath>
      <clipPath id="dk">
        <path d="m39.457 9.188 5.676 9.566s1.703-5.625.781-8.473c-.922-2.844-1.719-3.23-1.719-3.23-2.61.316-4.738 2.136-4.738 2.136" />
      </clipPath>
      <clipPath id="dm">
        <path d="M42 7h4v7h-4Zm0 0" />
      </clipPath>
      <clipPath id="dn">
        <path d="M44.195 7.05a9.04 9.04 0 0 0-2.11 5.852l.817.508 2.375-4.87s-.765-1.49-1.07-1.493h-.012" />
      </clipPath>
      <clipPath id="dp">
        <path d="M42 7h6v13h-6Zm0 0" />
      </clipPath>
      <clipPath id="dq">
        <path d="m42.824 13.164 3.223 6.149a6.894 6.894 0 0 0 1.531-6.41c-.957-4.008-3.27-5.09-3.27-5.09-2.046 2.269-1.484 5.351-1.484 5.351" />
      </clipPath>
      <clipPath id="ds">
        <path d="M13 7h6v13h-6Zm0 0" />
      </clipPath>
      <clipPath id="dt">
        <path d="M13.715 12.902a6.886 6.886 0 0 0 1.535 6.41l3.223-6.148s.558-3.082-1.489-5.351c0 0-2.312 1.082-3.27 5.09" />
      </clipPath>
      <clipPath id="dv">
        <path d="M14 5h34v31H14Zm0 0" />
      </clipPath>
      <clipPath id="dw">
        <path d="M15.809 17.426c-1.825 4.828-2.036 10.074-.137 13.562 2.91 5.344 25.242 5.832 29.992-.773 1.598-2.223 1.762-5.742.813-9.438-1.875-7.308-8.098-15.308-16.2-15.308-6.882 0-12.07 5.62-14.468 11.957" />
      </clipPath>
      <clipPath id="dy">
        <path d="M16 6h29v22H16Zm0 0" />
      </clipPath>
      <clipPath id="dz">
        <path d="M29.996 6.523c-9.73.579-14.5 9.649-12.758 17.016 1.063 4.5 20.692 4.992 25.516.914 4.719-3.988-1.832-17.95-12.086-17.95-.223 0-.445.009-.672.02" />
      </clipPath>
      <clipPath id="dB">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="ag">
        <path d="M14.34 17.422h32.719v17.66h-32.72Zm0 0" />
      </clipPath>
      <clipPath id="ah">
        <path d="M45.664 30.215c-4.754 6.605-27.086 6.113-29.992.773-1.899-3.492-1.692-8.734.137-13.562 0-.004 0-.004.004-.004-.083.285-1.954 7.05-.04 10.027 1.954 3.047 9.68 2.625 17.977 2.274 8.297-.352 11.043-1.547 12.434-3.868 1.097-1.828-.004-5.855-.524-7.484l.813 2.406c.949 3.7.785 7.22-.809 9.438" />
      </clipPath>
      <clipPath id="af">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="dE">
        <path d="M18 30h24v6H18Zm0 0" />
      </clipPath>
      <clipPath id="dF">
        <path d="M21.105 31.2c-1.433.26-2.347.581-2.402.945-.086.597.508 1.18 1.738 1.667h.004c1.871.743 5.215 1.258 9.86 1.266 4.191.004 12.023-1.441 11.586-2.933a.666.666 0 0 0-.133-.227c-.254-.297-.832-.54-1.64-.734l-.04-.008a3.33 3.33 0 0 0-.21-.051c-.34-.074-.72-.145-1.122-.203a52.883 52.883 0 0 0-7.332-.426c-3.45-.035-6.898.2-10.309.703" />
      </clipPath>
      <clipPath id="dH">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="ak">
        <path d="M18.695 30.496H41.84v3.317H18.695Zm0 0" />
      </clipPath>
      <clipPath id="al">
        <path d="M41.836 31.777a.617.617 0 0 1-.078.141c-.453.637-2.301 1.457-2.301 1.457s-7.086-2.875-12.828-1.598c-5.746 1.278-6.184 2.035-6.184 2.035h-.004c-1.23-.488-1.824-1.07-1.738-1.667.055-.364.965-.684 2.399-.946 4.218-.758 12.941-.984 17.644-.277.492.086.938.172 1.332.254l.04.008c1.112.238 1.773.449 1.718.593" />
      </clipPath>
      <clipPath id="aj">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="dK">
        <path d="M21 30h19v4H21Zm0 0" />
      </clipPath>
      <clipPath id="dL">
        <path d="M21.105 31.2c.758 1.01 4.024 1.85 9.403 1.863 3 0 8.262-.899 9.36-1.938-1.977-.438-5.15-.629-8.442-.629-3.453-.035-6.903.2-10.32.703" />
      </clipPath>
      <clipPath id="dN">
        <path d="M21 32h19v27H21Zm0 0" />
      </clipPath>
      <clipPath id="dO">
        <path d="M23.875 36.172c0 .004-.004.004-.004.004-.3.453-.57.926-.808 1.414l-.004.004c-.27.558-.5 1.133-.688 1.722-1.277 4.008-1.644 10.442-.687 13.918.957 3.477 4.578 5.063 8.855 5.063 4.914 0 8.34-2.531 8.992-6.324.559-3.664.39-7.403-.496-11-.004-.012-.004-.024-.004-.035a25.079 25.079 0 0 0-1.054-3.352 8.892 8.892 0 0 0-1.528-2.547 7.87 7.87 0 0 0-6.148-2.719c-2.582 0-4.867 1.524-6.426 3.852" />
      </clipPath>
      <clipPath id="dQ">
        <path d="M36 34h4v8h-4Zm0 0" />
      </clipPath>
      <clipPath id="dR">
        <path d="M39.262 41.988s-.739-4.203-3.09-7.25c0 0 .422 4.508 3.09 7.25" />
      </clipPath>
      <clipPath id="dT">
        <path d="M36 25h16v16H36Zm0 0" />
      </clipPath>
      <clipPath id="dU">
        <path d="M36.73 33.781a.375.375 0 0 0-.125.098l-.003.004c-.7.828 1.07 5.078 3.097 6.383a23.934 23.934 0 0 0 11.567-11.04 6.06 6.06 0 0 0-.528-2.55 2.674 2.674 0 0 0-2.308-1.594s-2.696 4.43-11.7 8.7" />
      </clipPath>
      <clipPath id="dW">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="ao">
        <path d="M14.547 26.332h7.742v4.656h-7.742Zm0 0" />
      </clipPath>
      <clipPath id="ap">
        <path d="M15.676 30.988a8.992 8.992 0 0 1 2.793-1.968c1.847-.88 3.55-1.57 3.812-2.274.262-.707-5.078-.293-5.078-.293l-2.656 1.145c.23 1.172.61 2.312 1.129 3.39" />
      </clipPath>
      <clipPath id="an">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="dZ">
        <path d="M47 25h5v6h-5Zm0 0" />
      </clipPath>
      <clipPath id="ea">
        <path d="M48.43 25.082c-.75.195-.676 5.133.285 5.621.957.492 2.55-1.476 2.55-1.476s-.152-4.215-2.328-4.215a2.21 2.21 0 0 0-.507.07" />
      </clipPath>
      <clipPath id="ec">
        <path d="M34 11h6v6h-6Zm0 0" />
      </clipPath>
      <clipPath id="ed">
        <path d="M36.445 11.863c-2.48.282-2.578 3.793-2.234 4.395.707 1.238 5.406.137 5.672-.598.336-.941-.848-3.812-3.125-3.812-.106 0-.211.004-.313.015" />
      </clipPath>
      <clipPath id="ef">
        <path d="M21 11h7v6h-7Zm0 0" />
      </clipPath>
      <clipPath id="eg">
        <path d="M21.2 15.66c.265.735 4.964 1.836 5.671.598.344-.602.25-4.113-2.234-4.395a2.79 2.79 0 0 0-.313-.015c-2.277 0-3.465 2.87-3.125 3.812" />
      </clipPath>
      <clipPath id="ei">
        <path d="M7 14h11v14H7Zm0 0" />
      </clipPath>
      <clipPath id="ej">
        <path d="M8.582 21.047c-2.2 3.762-1.312 5.848-1.312 5.848 2.605 1.761 10.156.296 10.156.296l-.317-1.054s-8.89 1.527-9.203-1.63c-.37-3.788 6.063-7.26 6.063-7.26.902-2.036-.473-2.915-.473-2.915a43.727 43.727 0 0 0-4.914 6.715" />
      </clipPath>
      <clipPath id="el">
        <path d="M15 24h8v4h-8Zm0 0" />
      </clipPath>
      <clipPath id="em">
        <path d="M15.98 25.844c-.808.906.91 1.902 2.325 2.054 1.586.172 4.402-.453 4.23-2.035-.09-.851-1.433-1.41-2.953-1.41-1.297 0-2.723.406-3.602 1.39" />
      </clipPath>
      <clipPath id="eo">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="as">
        <path d="M20.445 7.047h21.39v8.668h-21.39Zm0 0" />
      </clipPath>
      <clipPath id="at">
        <path d="M20.457 12.164c-.242 1.457 3.027 1.395 7.48 1.246 5.356-.176 10.735 4.395 13.864 1.117.515-.543-4.61-7.636-10.797-7.48-6.184.16-10.332 3.851-10.547 5.117" />
      </clipPath>
      <clipPath id="ar">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="aw">
        <path d="M23.469 23.934h15.203v2.812H23.469Zm0 0" />
      </clipPath>
      <clipPath id="ax">
        <path d="M23.492 24.855c-.281 1.06 1.95 2.114 7.43 1.848 6.625-.32 8.031-1.7 7.707-2.078-.195-.23-2.18 1.008-7.625-.172-3.594-.781-7.215-.707-7.512.402" />
      </clipPath>
      <clipPath id="av">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="aA">
        <path d="M45.457 17.75h.16v.48h-.16Zm0 0" />
      </clipPath>
      <clipPath id="aB">
        <path d="m45.617 18.23-.16-.48c.031.094.09.258.16.48" />
      </clipPath>
      <clipPath id="az">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="aE">
        <path d="M21.14 37.59h18.72v20.707H21.14Zm0 0" />
      </clipPath>
      <clipPath id="aF">
        <path d="M39.527 51.973c-.648 3.793-4.074 6.324-8.988 6.324-4.277 0-7.902-1.582-8.86-5.063-.956-3.48-.585-9.91.692-13.918.188-.59.418-1.164.688-1.722l.003-.004s-2.59 8.504-.519 13.922c2.07 5.418 11.707 5.304 14.969 1.703 3.105-3.426 1.672-11.473 1.527-12.242a28.13 28.13 0 0 1 .492 11" />
      </clipPath>
      <clipPath id="aD">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="ex">
        <path d="M21 41h18v17H21Zm0 0" />
      </clipPath>
      <clipPath id="ey">
        <path d="M21.867 49.719c-.687 4.765 3.328 8.156 8.625 8.156 5.297 0 8.25-3.129 8.32-7.137.07-4.004-2.582-8.675-7.515-9.136a8.432 8.432 0 0 0-.766-.036c-4.265 0-7.976 3.344-8.664 8.153" />
      </clipPath>
      <clipPath id="eA">
        <path d="M21 41h18v18H21Zm0 0" />
      </clipPath>
      <clipPath id="eB">
        <path d="M21.91 50.14c-.683 4.766 3.332 8.157 8.63 8.157 5.296 0 8.25-3.129 8.32-7.137.07-4.004-2.583-8.676-7.516-9.137a8.432 8.432 0 0 0-.766-.035c-4.265 0-7.976 3.344-8.668 8.153" />
      </clipPath>
      <clipPath id="eD">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="aI">
        <path d="M23.836 32.32h12.613v5.047H23.836Zm0 0" />
      </clipPath>
      <clipPath id="aJ">
        <path d="M36.45 35.04c-1.048 1.628-6.813 2.573-10.141 2.273-2.899-.262-2.461-1.04-2.438-1.137 0 0 .004 0 .004-.004 1.559-2.328 3.844-3.852 6.426-3.852a7.869 7.869 0 0 1 6.148 2.72" />
      </clipPath>
      <clipPath id="aH">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="eG">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="aM">
        <path d="M24.809 54.563h11.785v2.824H24.809Zm0 0" />
      </clipPath>
      <clipPath id="aN">
        <path d="M24.809 55.328s1.183 2.043 5.59 2.059c4.406.02 6.195-2.582 6.195-2.582a6.483 6.483 0 0 1-4.942.523c-2.902-.789-5.777-1.23-6.843 0" />
      </clipPath>
      <clipPath id="aL">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="eJ">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="aQ">
        <path d="M36.445 25.465H51.27v14.8H36.445Zm0 0" />
      </clipPath>
      <clipPath id="aR">
        <path d="M51.266 29.23a23.944 23.944 0 0 1-11.567 11.036c-2.027-1.301-3.797-5.555-3.097-6.383l.003-.004c.04-.035.083-.066.125-.098 0 0 1.317 4.797 5.176 3.469 4.578-1.578 6.453-9.469 6.453-9.469v-2.316l2.38 1.215c.359.8.538 1.672.527 2.55" />
      </clipPath>
      <clipPath id="aP">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="eM">
        <path d="M48 17h7v13h-7Zm0 0" />
      </clipPath>
      <clipPath id="eN">
        <path d="M50.219 19.305s-1.985 4.953-2.055 7.168c0 0-.035 2.601 1.453 3.023 1.488.422 3.352-2.336 4.043-3.48.692-1.141 1.735-6.29.742-7.52a1.954 1.954 0 0 0-1.554-.746c-.883 0-1.868.527-2.63 1.555" />
      </clipPath>
      <clipPath id="eP">
        <path d="M48 17h5v9h-5Zm0 0" />
      </clipPath>
      <clipPath id="eQ">
        <path d="M50.219 19.305c-1.524 1.648-1.973 6.394-1.973 6.394a6.129 6.129 0 0 0 2.117-3.304c.387-2.004 2.48-4.645 2.48-4.645h-.038c-.203 0-1.227.078-2.586 1.55" />
      </clipPath>
      <clipPath id="eS">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="aU">
        <path d="M49.313 19.645h1.953v4.605h-1.953Zm0 0" />
      </clipPath>
      <clipPath id="aV">
        <path d="m49.945 19.645 1.32.496a8.412 8.412 0 0 0-.82 1.906 8.912 8.912 0 0 1-1.133 2.203Zm0 0" />
      </clipPath>
      <clipPath id="aT">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="eV">
        <path d="M47 18h4v8h-4Zm0 0" />
      </clipPath>
      <clipPath id="eW">
        <path d="M48.332 18.672c-.21.262-.664 1.754-.605 3.652-.004.985.171 1.961.515 2.887 1.535-.457 2.012-3.836 2.012-3.836s-.254-2.086-.61-2.508a1.118 1.118 0 0 0-.835-.363.616.616 0 0 0-.477.168" />
      </clipPath>
      <clipPath id="eY">
        <path d="M50 22h4v5h-4Zm0 0" />
      </clipPath>
      <clipPath id="eZ">
        <path d="M50.36 22.395s.886 2.902 3.023 4.062l.277-.441a7.566 7.566 0 0 1-3.215-3.97Zm0 0" />
      </clipPath>
      <clipPath id="fb">
        <path d="M16 24h6v3h-6Zm0 0" />
      </clipPath>
      <clipPath id="fc">
        <path d="M16.09 26.012c-.047.258 5.613.32 5.746-.672.062-.469-1.129-.793-2.45-.793-1.472 0-3.1.406-3.296 1.465" />
      </clipPath>
      <clipPath id="fe">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="aY">
        <path d="M17.39 15.254h2.223v7.7h-2.222Zm0 0" />
      </clipPath>
      <clipPath id="aZ">
        <path d="M17.48 22.059a14.306 14.306 0 0 1 .043-3.586c.274-2.059.829-3.387 1.16-3.2.333.188.282 2.2.477 4.184a32.4 32.4 0 0 0 .453 2.992s-1.433 1.36-2.129-.39" />
      </clipPath>
      <clipPath id="aX">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bc">
        <path d="M23.645 42.648h14.304v6.758H23.645Zm0 0" />
      </clipPath>
      <clipPath id="bd">
        <path d="M23.66 46.91c.871 1.375 4.45.64 8.485 1.031 4.035.391 4.722 1.692 5.574 1.43.847-.266-.496-6.285-6.52-6.695-6.027-.406-7.754 3.89-7.539 4.234" />
      </clipPath>
      <clipPath id="bb">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="fj">
        <path d="M51 0h14v15H51Zm0 0" />
      </clipPath>
      <clipPath id="fk">
        <path d="M51.434.406s-.032 7.946.574 11.793l6.207 2.426-.992-1.723 6.027-.68s.637-8.933.852-11.816A34.3 34.3 0 0 0 58.234 0c-2.27.004-4.543.14-6.8.406" />
      </clipPath>
      <clipPath id="fm">
        <path d="M0 0h69.832v74H0Zm0 0" />
      </clipPath>
      <clipPath id="bg">
        <path d="M43.43 8.91h3.02v3.563h-3.02Zm0 0" />
      </clipPath>
      <clipPath id="bh">
        <path d="M46.074 9.629s-.75-.922-1.773-.68c-1.02.246-1.09 3.442-.477 3.52.61.078.871-1.766 1.34-2.055a2.34 2.34 0 0 1 1.285-.18Zm0 0" />
      </clipPath>
      <clipPath id="bf">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="bk">
        <path d="M14.48 8.242h3.329v3.973H14.48Zm0 0" />
      </clipPath>
      <clipPath id="bl">
        <path d="M14.48 10.738a1.414 1.414 0 0 1 1.282-.3c.886.144 1.398 1.945 1.851 1.765.453-.183.121-3.101-1.078-3.96 0 0-1.547 1.304-2.055 2.491" />
      </clipPath>
      <clipPath id="bj">
        <path d="M0 0h70v74H0z" />
      </clipPath>
      <clipPath id="fr">
        <path d="M10 14h4v5h-4Zm0 0" />
      </clipPath>
      <clipPath id="fs">
        <path d="M10.332 18.73c.191.254 3.133-3.378 2.945-3.738 0 0-3.136 3.492-2.945 3.738" />
      </clipPath>
      <linearGradient
        id="cp"
        gradientUnits="userSpaceOnUse"
        x1={-3.488}
        y1={6.466}
        x2={-3.465}
        y2={6.466}
        gradientTransform="matrix(1.181 -16.4419 13.36537 .94365 52.678 15.269)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#a242ea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fe117e',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="cs"
        gradientUnits="userSpaceOnUse"
        x1={-1.294}
        y1={1.921}
        x2={-1.27}
        y2={1.921}
        gradientTransform="matrix(2.04209 -16.11924 13.06376 1.6268 17.545 67.752)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#cbc1f7',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e8dcf7',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="cv"
        gradientUnits="userSpaceOnUse"
        x1={-1.75}
        y1={1.863}
        x2={-1.729}
        y2={1.863}
        gradientTransform="matrix(2.30385 -18.1855 13.85163 1.72491 27.96 68.896)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#cbc1f7',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e8dcf7',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="cy"
        gradientUnits="userSpaceOnUse"
        x1={-2.33}
        y1={3.61}
        x2={-2.291}
        y2={3.61}
        gradientTransform="matrix(8.75 0 0 5.60547 20.387 53.988)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="cB"
        gradientUnits="userSpaceOnUse"
        x1={-3.837}
        y1={3.551}
        x2={-3.796}
        y2={3.551}
        gradientTransform="matrix(8.27344 0 0 5.91016 31.754 53.215)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="S"
        gradientUnits="userSpaceOnUse"
        x1={-2.582}
        y1={1.585}
        x2={-2.54}
        y2={1.585}
        gradientTransform="matrix(8.14453 0 0 13.28906 21.023 53.129)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#9d68c2',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#ccedff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="W"
        gradientUnits="userSpaceOnUse"
        x1={-3.906}
        y1={1.446}
        x2={-3.865}
        y2={1.446}
        gradientTransform="matrix(8.17578 0 0 14.85938 31.95 52.707)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#9d68c2',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#ccedff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="cK"
        gradientUnits="userSpaceOnUse"
        x1={-0.35}
        y1={2.757}
        x2={-0.334}
        y2={2.757}
        gradientTransform="matrix(3.0122 -23.77684 17.87177 2.22553 7.413 56.287)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#cbc1f7',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e8dcf7',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="cN"
        gradientUnits="userSpaceOnUse"
        x1={-2.269}
        y1={5.375}
        x2={-2.208}
        y2={5.375}
        gradientTransform="matrix(5.57813 0 0 4.10156 12.664 52.121)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="aa"
        gradientUnits="userSpaceOnUse"
        x1={-1.213}
        y1={2.117}
        x2={-1.18}
        y2={2.117}
        gradientTransform="matrix(10.42188 0 0 17.05469 12.64 38.102)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#9d68c2',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#ccedff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="cT"
        gradientUnits="userSpaceOnUse"
        x1={-0.762}
        y1={2.624}
        x2={-0.734}
        y2={2.624}
        gradientTransform="matrix(1.73227 -13.67368 10.26347 1.27809 9.252 64.895)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#cbc1f7',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e8dcf7',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="cW"
        gradientUnits="userSpaceOnUse"
        x1={-3.356}
        y1={2.025}
        x2={-3.276}
        y2={2.025}
        gradientTransform="matrix(4.22266 0 0 9.89063 14.18 54.18)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="ae"
        gradientUnits="userSpaceOnUse"
        x1={-6.132}
        y1={4.322}
        x2={-5.996}
        y2={4.322}
        gradientTransform="matrix(2.4961 0 0 3.9375 15.309 57.184)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#8da4e5',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#755cbb',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="dc"
        gradientUnits="userSpaceOnUse"
        x1={-1.805}
        y1={4.604}
        x2={-1.76}
        y2={4.604}
        gradientTransform="matrix(1.05635 -8.3383 5.80642 .72306 13.828 61.706)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#cbc1f7',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e8dcf7',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="df"
        gradientUnits="userSpaceOnUse"
        x1={-1.96}
        y1={5.736}
        x2={-1.914}
        y2={5.736}
        gradientTransform="matrix(7.3789 0 0 11.70313 14.457 7.05)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#b9acf4',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e1d1f5',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="di"
        gradientUnits="userSpaceOnUse"
        x1={-5.101}
        y1={9.219}
        x2={-4.993}
        y2={9.219}
        gradientTransform="matrix(3.15234 0 0 7.28125 16.09 7.05)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="dl"
        gradientUnits="userSpaceOnUse"
        x1={-5.349}
        y1={5.736}
        x2={-5.302}
        y2={5.736}
        gradientTransform="matrix(7.3789 0 0 11.70313 39.457 7.05)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#b9acf4',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e1d1f5',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="do"
        gradientUnits="userSpaceOnUse"
        x1={-13.189}
        y1={10.553}
        x2={-13.082}
        y2={10.553}
        gradientTransform="matrix(3.1875 0 0 6.36328 42.086 7.047)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="dr"
        gradientUnits="userSpaceOnUse"
        x1={-6.735}
        y1={5.772}
        x2={-6.68}
        y2={5.772}
        gradientTransform="matrix(6.27344 0 0 11.5 42.262 7.813)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#45ffcd',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#22e0ff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="du"
        gradientUnits="userSpaceOnUse"
        x1={-2.033}
        y1={5.772}
        x2={-1.979}
        y2={5.772}
        gradientTransform="matrix(6.27344 0 0 11.5 12.758 7.813)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#45ffcd',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#22e0ff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="dx"
        gradientUnits="userSpaceOnUse"
        x1={-0.36}
        y1={1.934}
        x2={-0.351}
        y2={1.934}
        gradientTransform="matrix(5.5831 -44.07033 45.76376 5.69886 4.928 40.33)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#cbc1f7',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e8dcf7',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="dA"
        gradientUnits="userSpaceOnUse"
        x1={-0.485}
        y1={3.072}
        x2={-0.474}
        y2={3.072}
        gradientTransform="matrix(31.97266 0 0 22.02734 15.496 6.504)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#0665bd',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#1a1f77',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="ai"
        gradientUnits="userSpaceOnUse"
        x1={-0.409}
        y1={2.927}
        x2={-0.399}
        y2={2.927}
        gradientTransform="matrix(33.65234 0 0 19.39844 13.773 17.422)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#9d68c2',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#ccedff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="dG"
        gradientUnits="userSpaceOnUse"
        x1={-0.785}
        y1={9.529}
        x2={-0.771}
        y2={9.529}
        gradientTransform="matrix(23.71094 0 0 4.58594 18.617 30.496)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#8879ea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="am"
        gradientUnits="userSpaceOnUse"
        x1={-0.8}
        y1={12.224}
        x2={-0.785}
        y2={12.224}
        gradientTransform="matrix(23.27344 0 0 3.59766 18.617 30.215)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#8da4e5',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#755cbb',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="dM"
        gradientUnits="userSpaceOnUse"
        x1={-5.71}
        y1={2.758}
        x2={-5.641}
        y2={2.758}
        gradientTransform="matrix(1.19532 -9.43525 19.99499 2.48993 19.891 35.252)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#5e36cc',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#6c4a96',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="dP"
        gradientUnits="userSpaceOnUse"
        x1={-0.571}
        y1={1.795}
        x2={-0.559}
        y2={1.795}
        gradientTransform="matrix(4.23386 -33.42003 29.29378 3.6479 13.652 60.195)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#cbc1f7',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e8dcf7',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="dS"
        gradientUnits="userSpaceOnUse"
        x1={-11.71}
        y1={5.442}
        x2={-11.6}
        y2={5.442}
        gradientTransform="matrix(3.08984 0 0 7.25 36.172 34.738)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#8879ea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="dV"
        gradientUnits="userSpaceOnUse"
        x1={-2.048}
        y1={2.935}
        x2={-2.028}
        y2={2.935}
        gradientTransform="matrix(2.66351 -21.02449 21.27015 2.64873 31.643 41.862)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#cbc1f7',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e8dcf7',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="aq"
        gradientUnits="userSpaceOnUse"
        x1={-1.82}
        y1={9.729}
        x2={-1.777}
        y2={9.729}
        gradientTransform="matrix(7.9961 0 0 4.94922 14.547 26.04)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#8da4e5',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#755cbb',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="eb"
        gradientUnits="userSpaceOnUse"
        x1={-13.297}
        y1={7.952}
        x2={-13.202}
        y2={7.952}
        gradientTransform="matrix(3.58594 0 0 6.1875 47.68 25.012)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="ee"
        gradientUnits="userSpaceOnUse"
        x1={-5.329}
        y1={11.034}
        x2={-5.276}
        y2={11.034}
        gradientTransform="matrix(6.35547 0 0 5.64844 33.871 11.848)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#45ffcd',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#22e0ff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="eh"
        gradientUnits="userSpaceOnUse"
        x1={-3.282}
        y1={11.034}
        x2={-3.229}
        y2={11.034}
        gradientTransform="matrix(6.35547 0 0 5.64844 20.86 11.848)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#45ffcd',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#22e0ff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="ek"
        gradientUnits="userSpaceOnUse"
        x1={-0.258}
        y1={4.668}
        x2={-0.236}
        y2={4.668}
        gradientTransform="matrix(2.35065 -18.55487 16.5138 2.05643 2.474 29.743)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="en"
        gradientUnits="userSpaceOnUse"
        x1={-3.089}
        y1={6.42}
        x2={-3.024}
        y2={6.42}
        gradientTransform="matrix(2.04515 -8.61116 10.24639 2.39206 12.796 29.37)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#dd1a8f',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fe117e',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="au"
        gradientUnits="userSpaceOnUse"
        x1={-0.914}
        y1={6.165}
        x2={-0.899}
        y2={6.165}
        gradientTransform="matrix(22.10156 0 0 10.91406 20.215 6.89)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#000',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#6a9bff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="ay"
        gradientUnits="userSpaceOnUse"
        x1={-1.474}
        y1={15.317}
        x2={-1.453}
        y2={15.317}
        gradientTransform="matrix(15.74219 0 0 3.29688 23.21 23.672)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#000',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#6a9bff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="aC"
        gradientUnits="userSpaceOnUse"
        x1={-284.682}
        y1={117.924}
        x2={-282.55}
        y2={117.924}
        gradientTransform="matrix(.16016 0 0 .48047 45.457 17.75)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#9d68c2',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#ccedff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="aG"
        gradientUnits="userSpaceOnUse"
        x1={-1.017}
        y1={1.768}
        x2={-1}
        y2={1.768}
        gradientTransform="matrix(20.14063 0 0 20.70703 20.473 37.59)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#9d68c2',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#ccedff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="ez"
        gradientUnits="userSpaceOnUse"
        x1={-1.197}
        y1={2.001}
        x2={-1.177}
        y2={2.001}
        gradientTransform="matrix(17.70313 0 0 16.3086 21.18 41.566)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="aK"
        gradientUnits="userSpaceOnUse"
        x1={-1.795}
        y1={7.912}
        x2={-1.769}
        y2={7.912}
        gradientTransform="matrix(13.03906 0 0 5.29297 23.41 32.32)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#8da4e5',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#755cbb',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="aO"
        gradientUnits="userSpaceOnUse"
        x1={-2.106}
        y1={6.076}
        x2={-2.077}
        y2={6.076}
        gradientTransform="matrix(11.78516 0 0 3.3086 24.809 54.098)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#d4e2ff',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#000',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="aS"
        gradientUnits="userSpaceOnUse"
        x1={-2.329}
        y1={3.293}
        x2={-2.307}
        y2={3.293}
        gradientTransform="matrix(15.41406 0 0 14.80078 35.902 25.465)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#9d68c2',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#ccedff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="eO"
        gradientUnits="userSpaceOnUse"
        x1={-3.457}
        y1={6.31}
        x2={-3.431}
        y2={6.31}
        gradientTransform="matrix(1.89977 -14.99587 11.88438 1.47994 44.87 30.592)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#cbc1f7',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e8dcf7',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="eR"
        gradientUnits="userSpaceOnUse"
        x1={-10.487}
        y1={7.098}
        x2={-10.413}
        y2={7.098}
        gradientTransform="matrix(4.60156 0 0 7.95313 48.242 17.75)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="aW"
        gradientUnits="userSpaceOnUse"
        x1={-25.21}
        y1={11.843}
        x2={-25.036}
        y2={11.843}
        gradientTransform="matrix(1.95313 0 0 4.60547 49.313 19.645)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#8da4e5',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#755cbb',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="eX"
        gradientUnits="userSpaceOnUse"
        x1={-6.461}
        y1={15.978}
        x2={-6.413}
        y2={15.978}
        gradientTransform="matrix(.98154 -7.74783 5.1071 .63598 45.917 25.413)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#cbc1f7',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e8dcf7',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="fa"
        gradientUnits="userSpaceOnUse"
        x1={-15.274}
        y1={11.831}
        x2={-15.171}
        y2={11.831}
        gradientTransform="matrix(3.30078 0 0 4.41016 50.36 22.047)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#9e8cef',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="fd"
        gradientUnits="userSpaceOnUse"
        x1={-2.739}
        y1={27.839}
        x2={-2.681}
        y2={27.839}
        gradientTransform="matrix(5.85547 0 0 1.78516 16.043 24.547)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#d93de3',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#ff6dba',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="ba"
        gradientUnits="userSpaceOnUse"
        x1={-1.562}
        y1={19.184}
        x2={-1.524}
        y2={19.184}
        gradientTransform="matrix(.63905 -9.24142 4.16435 .28306 16.03 23.926)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#000',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#00e3ff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="be"
        gradientUnits="userSpaceOnUse"
        x1={-1.55}
        y1={4.335}
        x2={-1.528}
        y2={4.335}
        gradientTransform="matrix(15.125 0 0 7.36328 23.445 42.27)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#000',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#d4e2ff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="fl"
        gradientUnits="userSpaceOnUse"
        x1={-3.199}
        y1={5.419}
        x2={-3.177}
        y2={5.419}
        gradientTransform="matrix(1.24649 -17.35377 15.8747 1.12082 49.187 15.433)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#d93de3',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#ff6dba',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="bi"
        gradientUnits="userSpaceOnUse"
        x1={-13.341}
        y1={17.05}
        x2={-13.236}
        y2={17.05}
        gradientTransform="matrix(3.23828 0 0 3.83984 43.21 8.707)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#000',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#d4e2ff',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="bm"
        gradientUnits="userSpaceOnUse"
        x1={-4.039}
        y1={15.918}
        x2={-3.944}
        y2={15.918}
        gradientTransform="matrix(3.58594 0 0 4.14063 14.48 8.242)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#d4e2ff',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#000',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="ft"
        gradientUnits="userSpaceOnUse"
        x1={-2.394}
        y1={17.525}
        x2={-2.311}
        y2={17.525}
        gradientTransform="matrix(.0691 -4.15306 3.52425 .05763 10.006 19.034)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#cbc1f7',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#e8dcf7',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <mask id="bp">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bs">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bw">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bz">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bC">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bE">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bG">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bI">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bL">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bO">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bR">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bU">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="bX">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="ca">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="cc">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="ce">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="cg">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="cj">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="cm">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="cE">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.301961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="cH">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.301961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="cQ">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.301961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="cZ">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="dD">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.301961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="dJ">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="dY">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="eq">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="es">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="eu">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.301961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="ew">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.301961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="eF">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="eI">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.721569,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="eL">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.301961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="eU">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.501961,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="fg">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.2,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="fi">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.721569,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="fo">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.721569,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <mask id="fq">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.721569,
              stroke: 'none',
            }}
            d="M0 0h70v74H0z"
          />
        </g>
      </mask>
      <g clipPath="url(#b)">
        <g clipPath="url(#c)" id="bo">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#e5f6ff',
              fillOpacity: 1,
            }}
            d="M69.738 10.5c.14-.027.11-.266-.02-.32a.529.529 0 0 0-.413.066.5.5 0 0 0 .437.344Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#d)">
        <g clipPath="url(#e)" id="br">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#e5f6ff',
              fillOpacity: 1,
            }}
            d="M65.781 9.195c0-.05-.004-.097-.004-.144a.175.175 0 0 0-.21.05.131.131 0 0 0-.02.114c.008.035.031.07.066.09a.134.134 0 0 0 .11-.004.122.122 0 0 0 .062-.09Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#f)">
        <g clipPath="url(#g)" id="bv">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#e5f6ff',
              fillOpacity: 1,
            }}
            d="M62.676 12.227a.625.625 0 0 0 .172-.114.173.173 0 0 0 .03-.195c-.054-.102-.21-.086-.304-.145-.097-.062-.136-.207-.25-.234-.117-.027-.215.094-.21.207a.468.468 0 0 0 .152.3.528.528 0 0 0 .242.18.223.223 0 0 0 .265-.093Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#h)">
        <g clipPath="url(#i)" id="by">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#e5f6ff',
              fillOpacity: 1,
            }}
            d="M64.703 10.89a.13.13 0 0 1-.129-.124.232.232 0 0 1 .086-.176.212.212 0 0 1 .102-.063c.043-.007.09 0 .129.028a.16.16 0 0 1 .07.11.184.184 0 0 1-.152.194.196.196 0 0 1-.207-.14Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#j)">
        <g clipPath="url(#k)" id="bB">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#e5f6ff',
              fillOpacity: 1,
            }}
            d="M62.7 10.629a.258.258 0 0 1-.243-.145.25.25 0 0 1 .035-.277c.047-.05.137-.078.18-.027.016.023.023.05.027.078l.051.375h-.066Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#l)">
        <g clipPath="url(#m)" id="bD">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#e5f6ff',
              fillOpacity: 1,
            }}
            d="M61.754 8.914c.02-.121-.102-.219-.211-.277-.11-.059-.238-.133-.246-.254a.115.115 0 0 1 .031-.094c.067-.055.156.031.238.066a.89.89 0 0 0 .204.04c.167.039.296.171.324.34a.231.231 0 0 1-.422.031Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#n)">
        <g clipPath="url(#o)" id="bF">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#e5f6ff',
              fillOpacity: 1,
            }}
            d="M67.543 18.547c.02-.121-.102-.219-.211-.277-.11-.06-.238-.133-.246-.254a.095.095 0 0 1 .031-.094c.067-.055.156.031.238.066a.89.89 0 0 0 .204.04c.168.038.296.171.324.34a.234.234 0 0 1-.203.152.228.228 0 0 1-.22-.122Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#p)">
        <g clipPath="url(#q)" id="bH">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#e5f6ff',
              fillOpacity: 1,
            }}
            d="m62.86 8.34.117-.082a.174.174 0 0 0-.16-.145.15.15 0 0 0-.106.043.138.138 0 0 0-.04.106c.009.039.032.074.067.09a.12.12 0 0 0 .11.003Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#r)">
        <g clipPath="url(#s)" id="bK">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#e5f6ff',
              fillOpacity: 1,
            }}
            d="m65.895 10.527.117-.093a.312.312 0 0 0-.16-.157c-.075-.023-.172.047-.145.118a.15.15 0 0 0 .059.062l.222.164Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#t)">
        <g clipPath="url(#u)" id="bN">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#fff',
              fillOpacity: 1,
            }}
            d="M26.727 50.137c-.043-.09-.196-.035-.215.062a.35.35 0 0 0 .105.262.334.334 0 0 0 .164-.344Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#v)">
        <g clipPath="url(#w)" id="bQ">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#fff',
              fillOpacity: 1,
            }}
            d="m26.445 52.941-.093.024a.118.118 0 0 0 .066.133.108.108 0 0 0 .078-.004.095.095 0 0 0 .05-.059.093.093 0 0 0-.019-.07.098.098 0 0 0-.07-.031Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#x)">
        <g clipPath="url(#y)" id="bT">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#fff',
              fillOpacity: 1,
            }}
            d="M28.95 54.531a.345.345 0 0 0-.102-.097.124.124 0 0 0-.137.007c-.059.055-.023.153-.05.227-.028.074-.118.121-.118.2-.004.077.094.124.172.105a.321.321 0 0 0 .176-.145.376.376 0 0 0 .086-.187.149.149 0 0 0-.106-.16Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#z)">
        <g clipPath="url(#A)" id="bW">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#fff',
              fillOpacity: 1,
            }}
            d="M27.746 53.395a.089.089 0 0 1-.066.105.174.174 0 0 1-.13-.031.157.157 0 0 1-.058-.055.12.12 0 0 1 0-.09.116.116 0 0 1 .063-.066.133.133 0 0 1 .156.074.132.132 0 0 1-.066.156Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#B)">
        <g clipPath="url(#C)" id="bZ">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#fff',
              fillOpacity: 1,
            }}
            d="M27.875 54.754a.174.174 0 0 1-.059.184.186.186 0 0 1-.195.019c-.039-.023-.07-.078-.043-.113a.09.09 0 0 1 .047-.032l.246-.09a.14.14 0 0 0 .008.044Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#D)">
        <g clipPath="url(#E)" id="cb">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#fff',
              fillOpacity: 1,
            }}
            d="M26.867 55.637c-.086.008-.129.101-.152.183-.024.082-.055.176-.137.2a.068.068 0 0 1-.066-.008c-.047-.035-.004-.106.008-.164a.597.597 0 0 0-.004-.145c0-.113.07-.219.18-.262a.16.16 0 0 1 .132.11c.02.058 0 .125-.047.164Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#F)">
        <g clipPath="url(#G)" id="cd">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#fff',
              fillOpacity: 1,
            }}
            d="M32.453 50.367c-.086.008-.129.102-.152.18-.024.082-.055.18-.133.203a.079.079 0 0 1-.066-.008c-.047-.035-.004-.11.007-.168a.567.567 0 0 0-.007-.14c0-.114.07-.22.18-.262a.15.15 0 0 1 .132.11c.02.058 0 .12-.047.163Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#H)">
        <g clipPath="url(#I)" id="cf">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#fff',
              fillOpacity: 1,
            }}
            d="m26.316 54.996-.074-.062a.11.11 0 0 0-.07.125c.004.027.02.05.043.062.023.016.05.02.078.012a.095.095 0 0 0 .05-.059c.009-.023 0-.05-.015-.074Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#J)">
        <g clipPath="url(#K)" id="ci">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: '#fff',
              fillOpacity: 1,
            }}
            d="m27.324 52.664-.082-.062a.238.238 0 0 0-.082.128c0 .055.059.106.102.079a.135.135 0 0 0 .035-.047l.074-.176Zm0 0"
          />
        </g>
      </g>
      <g clipPath="url(#L)">
        <g clipPath="url(#M)" id="cl">
          <g clipPath="url(#N)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#O)',
              }}
              d="M17.898 68.066h27.77v6.13h-27.77Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#P)">
        <g clipPath="url(#Q)" id="cD">
          <g clipPath="url(#R)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#S)',
              }}
              d="M21.023 53.129h8.145v13.289h-8.145Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#T)">
        <g clipPath="url(#U)" id="cG">
          <g clipPath="url(#V)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#W)',
              }}
              d="M31.95 52.707h8.175v14.86h-8.176Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#X)">
        <g clipPath="url(#Y)" id="cP">
          <g clipPath="url(#Z)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#aa)',
              }}
              d="M12.64 38.102h10.422v17.054H12.642Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#ab)">
        <g clipPath="url(#ac)" id="cY">
          <g clipPath="url(#ad)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#ae)',
              }}
              d="M15.309 57.184h2.496v3.937h-2.496Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#af)">
        <g clipPath="url(#ag)" id="dC">
          <g clipPath="url(#ah)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#ai)',
              }}
              d="M13.773 17.422h33.653V36.82H13.773Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#aj)">
        <g clipPath="url(#ak)" id="dI">
          <g clipPath="url(#al)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#am)',
              }}
              d="M18.617 30.215h23.274v3.598H18.617Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#an)">
        <g clipPath="url(#ao)" id="dX">
          <g clipPath="url(#ap)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#aq)',
              }}
              d="M14.547 26.04h7.996v4.948h-7.996Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#ar)">
        <g clipPath="url(#as)" id="ep">
          <g clipPath="url(#at)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#au)',
              }}
              d="M20.215 6.89h22.101v10.915H20.215Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#av)">
        <g clipPath="url(#aw)" id="er">
          <g clipPath="url(#ax)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#ay)',
              }}
              d="M23.21 23.672h15.743v3.297H23.211Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#az)">
        <g clipPath="url(#aA)" id="et">
          <g clipPath="url(#aB)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#aC)',
              }}
              d="M45.457 17.75h.16v.48h-.16Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#aD)">
        <g clipPath="url(#aE)" id="ev">
          <g clipPath="url(#aF)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#aG)',
              }}
              d="M20.473 37.59h20.14v20.707h-20.14Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#aH)">
        <g clipPath="url(#aI)" id="eE">
          <g clipPath="url(#aJ)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#aK)',
              }}
              d="M23.41 32.32h13.04v5.293H23.41Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#aL)">
        <g clipPath="url(#aM)" id="eH">
          <g clipPath="url(#aN)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#aO)',
              }}
              d="M24.809 54.098h11.785v3.308H24.809Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#aP)">
        <g clipPath="url(#aQ)" id="eK">
          <g clipPath="url(#aR)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#aS)',
              }}
              d="M35.902 25.465h15.414v14.8H35.902Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#aT)">
        <g clipPath="url(#aU)" id="eT">
          <g clipPath="url(#aV)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#aW)',
              }}
              d="M49.313 19.645h1.953v4.605h-1.953Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#aX)">
        <g clipPath="url(#aY)" id="ff">
          <g clipPath="url(#aZ)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#ba)',
              }}
              d="m16.652 23.766.61-8.84 2.949.203-.61 8.84Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#bb)">
        <g clipPath="url(#bc)" id="fh">
          <g clipPath="url(#bd)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#be)',
              }}
              d="M23.445 42.27H38.57v7.363H23.445Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#bf)">
        <g clipPath="url(#bg)" id="fn">
          <g clipPath="url(#bh)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#bi)',
              }}
              d="M43.21 8.707h3.24v3.84h-3.24Zm0 0"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#bj)">
        <g clipPath="url(#bk)" id="fp">
          <g clipPath="url(#bl)">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#bm)',
              }}
              d="M14.48 8.242h3.586v4.14H14.48Zm0 0"
            />
          </g>
        </g>
      </g>
      <radialGradient
        id="O"
        gradientUnits="userSpaceOnUse"
        cx={0.5}
        cy={0.5}
        fx={0.5}
        fy={0.5}
        r={2.247}
        gradientTransform="matrix(6.1926 0 0 -1.36062 3.986 75.562)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#be9dea',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.388}
          style={{
            stopColor: '#e0bff5',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fff',
            stopOpacity: 1,
          }}
        />
      </radialGradient>
      <radialGradient
        id="eC"
        gradientUnits="userSpaceOnUse"
        cx={0.531}
        cy={0.845}
        fx={0.531}
        fy={0.845}
        r={0.763}
        gradientTransform="matrix(16.4462 0 0 -16.3086 19.722 106.39)"
      >
        <stop
          offset={0}
          style={{
            stopColor: '#45ffcd',
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#22e0ff',
            stopOpacity: 1,
          }}
        />
      </radialGradient>
      <filter id="a" filterUnits="objectBoundingBox" x="0%" y="0%" width="100%" height="100%">
        <feColorMatrix in="SourceGraphic" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
      </filter>
    </defs>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M60.14 53.285a14.746 14.746 0 0 1-3.117 4.29 7.802 7.802 0 0 1-1.07.823c-.336.22-.695.41-1.07.563-5.34 2.187-10.809-2.793-16.922-2.203-5.121.492-8.805 3.316-12.074 5.687a31.947 31.947 0 0 1-3.356 2.22c-.308.17-.62.327-.926.464-.332.148-.687.285-1.062.414h-.008c-4.73 1.61-12.726 1.55-16.27-1.914C.556 60-3.948 48.242 6.255 33.102 17.59 16.27 48.559 13.942 56.836 19.508c8.562 5.754 8.219 24.11 3.305 33.777"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M60.785 26.395a7.857 7.857 0 0 0 2.211-2.793c.094-.172.149-.36.16-.551a1.109 1.109 0 0 0-.59-.899 2.332 2.332 0 0 0-2.582.184 2.834 2.834 0 0 0-1.027 2.422c.012.504.223.984.59 1.336.39.347.973.37 1.387.054a.234.234 0 0 0-.355-.168ZM62.066 50.238a7.87 7.87 0 0 0 2.211-2.797c.094-.168.149-.355.16-.55a1.102 1.102 0 0 0-.59-.895 2.332 2.332 0 0 0-2.581.18 2.834 2.834 0 0 0-1.028 2.422c.012.507.223.988.59 1.34a1.1 1.1 0 0 0 1.387.054.228.228 0 0 0-.133-.18.237.237 0 0 0-.223.008Zm0 0"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M61.004 22.719a1.458 1.458 0 0 0 1.219-.715 1.53 1.53 0 0 0-1.176-.785.926.926 0 0 0-.988.855c.015.488.71.836 1.058.485ZM63.813 19.336a.763.763 0 0 0 .656.082.743.743 0 0 0-.117-.281.263.263 0 0 0-.266-.11c-.137.04-.184.2-.211.336l-.066-.097ZM63.383 20.129a.369.369 0 0 1-.153.137.564.564 0 0 1 .184-.48c.063-.075.152-.157.25-.126.063.024.102.094.152.137.11.086.305.098.32.234A.168.168 0 0 1 64 20.2a.51.51 0 0 1-.23-.015l-.504-.118Zm0 0"
    />
    <g clipPath="url(#bn)">
      <use xlinkHref="#bo" mask="url(#bp)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M65.79 7.234a.132.132 0 0 1-.13-.125.253.253 0 0 1 .086-.175.212.212 0 0 1 .102-.063.167.167 0 0 1 .129.027c.039.024.066.067.07.11a.177.177 0 0 1-.149.195.2.2 0 0 1-.21-.14ZM63.254 17.273c-.012.07.012.141.062.188a.21.21 0 0 0 .196.043.335.335 0 0 0-.008-.223.165.165 0 0 0-.18-.101.104.104 0 0 0-.078.066.103.103 0 0 0 .012.106ZM62.754 20.445c.11.137.273.22.45.22-.013-.142-.024-.278-.04-.419a.37.37 0 0 0-.05-.191.23.23 0 0 0-.34 0 .318.318 0 0 0-.02.363Zm0 0"
    />
    <g clipPath="url(#bq)">
      <use xlinkHref="#br" mask="url(#bs)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M63.285 18.309c-.078-.047-.18.043-.191.136 0 .09.008.184.02.278a.333.333 0 0 1-.126.25.163.163 0 0 1-.156.035.189.189 0 0 1-.082-.074 1.034 1.034 0 0 1-.21-.504.471.471 0 0 1 .241-.457.365.365 0 0 1 .367.039.346.346 0 0 1 .145.332ZM64.984 20.125c.09.086.227.086.313 0a.322.322 0 0 0 .074-.32c-.016-.047-.05-.102-.101-.098-.036.004-.063.04-.082.066l-.247.348ZM67.504 15.29a.39.39 0 0 1-.223-.255.368.368 0 0 1 .067-.328c.172.07.32.184.43.336a.334.334 0 0 1 .038.258.324.324 0 0 1-.164.207l-.3-.121ZM56.863 30.273a.108.108 0 0 1-.062.047c-.024.012-.051.008-.074-.008a.21.21 0 0 1-.098-.125.278.278 0 0 1-.027-.125.2.2 0 0 1 .175-.164.248.248 0 0 1 .22.114.166.166 0 0 1 .026.12c-.011.044-.05.071-.093.063ZM64.477 16.785l.148-.004a.307.307 0 0 0-.035-.218c-.043-.063-.164-.067-.184.007a.118.118 0 0 0 .008.082l.082.266ZM65.516 14.348a.88.88 0 0 0 .336-.141.31.31 0 0 0 .12-.32.309.309 0 0 0-.113-.14.344.344 0 0 0-.351-.009.335.335 0 0 0 .016.594ZM66.754 13.973l.164-.188a.42.42 0 0 0-.137-.125.227.227 0 0 0-.094.313Zm0 0"
    />
    <g clipPath="url(#bt)">
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: '#e5f6ff',
          fillOpacity: 1,
        }}
        d="M68.836 21.578c.219-.43.332-.906.332-1.383a.581.581 0 0 0-.035-.23.461.461 0 0 0-.367-.227.933.933 0 0 0-.907.496c-.16.336-.148.727.04 1.051.09.184.246.324.44.39.2.06.415-.027.513-.21a.09.09 0 0 0-.079-.043.096.096 0 0 0-.078.039Zm0 0"
      />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M59.066 19.625a.748.748 0 0 0 .579-.324.804.804 0 0 0-.262-.156.27.27 0 0 0-.281.074c-.086.11-.028.27.035.394l-.11-.039ZM59.39 18.016a.313.313 0 0 0 .141-.125.295.295 0 0 0 0-.184 2.688 2.688 0 0 1-.058-.5l-.532.652a.135.135 0 0 1-.046.047c-.07.04-.149-.031-.227-.039-.113-.008-.191.113-.227.223-.23.773.645.094.95-.078M58.89 21.14a.583.583 0 0 0 .493-.093l-.285-.313a.369.369 0 0 0-.157-.12.239.239 0 0 0-.183.038.239.239 0 0 0-.09.164c0 .133.082.25.207.301ZM60.484 19.563a.23.23 0 0 0 .254-.188.328.328 0 0 0-.136-.3c-.043-.028-.106-.052-.141-.016a.13.13 0 0 0-.027.097l.015.43ZM61.73 21.145a.88.88 0 0 0 .336-.141.31.31 0 0 0 .121-.32.28.28 0 0 0-.113-.137.335.335 0 0 0-.351-.012.335.335 0 0 0 .016.594ZM66.762 17.543c.02-.121-.102-.215-.211-.277-.11-.059-.239-.13-.246-.254a.107.107 0 0 1 .03-.09c.071-.059.161.027.24.062a.747.747 0 0 0 .206.04c.164.038.293.171.32.34a.227.227 0 0 1-.199.152.227.227 0 0 1-.222-.121ZM66.398 14.508c.02-.121-.101-.215-.21-.274-.11-.062-.239-.132-.25-.257a.1.1 0 0 1 .035-.09c.066-.059.156.027.234.062a.747.747 0 0 0 .207.04c.168.038.293.171.32.34a.223.223 0 0 1-.199.151.227.227 0 0 1-.222-.12ZM67.941 12.816a.679.679 0 0 0 .176-.242.079.079 0 0 0 .012-.043.089.089 0 0 0-.05-.074.195.195 0 0 0-.22.02.245.245 0 0 0-.078.207.164.164 0 0 0 .055.109c.031.031.082.031.117 0-.004-.004-.008-.012-.012-.012-.007-.004-.015-.004-.02 0ZM59.355 24.602a.748.748 0 0 0 .575-.32.688.688 0 0 0-.262-.157.262.262 0 0 0-.281.07c-.082.114-.024.27.035.395l-.11-.035ZM57.66 23.285a.197.197 0 0 0 .164.11.21.21 0 0 0 .184-.082.359.359 0 0 0-.14-.172.17.17 0 0 0-.208.023c-.023.027-.031.066-.023.102.011.035.039.066.07.078ZM60.965 21.371a.197.197 0 0 0 .164.11c.07.007.14-.024.18-.083a.347.347 0 0 0-.137-.171.177.177 0 0 0-.207.023.121.121 0 0 0-.024.102c.012.039.036.066.07.078ZM58.313 24.094c-.094.008-.122.14-.079.222.047.082.133.133.188.207.055.082.074.18.05.274a.165.165 0 0 1-.105.125.263.263 0 0 1-.11-.012c-.179-.05-.339-.144-.468-.277a.467.467 0 0 1-.082-.512.362.362 0 0 1 .313-.187c.132 0 .253.066.32.18ZM66.063 16.496c-.094.008-.122.14-.075.223.043.078.13.133.184.207.058.082.074.18.05.273a.165.165 0 0 1-.1.125.214.214 0 0 1-.11-.015 1.022 1.022 0 0 1-.473-.278.468.468 0 0 1-.082-.508.36.36 0 0 1 .316-.187.357.357 0 0 1 .317.18Zm0 0"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M67.04 17.215c-.095.004-.122.14-.075.219.047.082.133.132.183.21.059.079.075.18.051.274a.153.153 0 0 1-.101.121.177.177 0 0 1-.11-.012 1.022 1.022 0 0 1-.472-.277.474.474 0 0 1-.082-.512.376.376 0 0 1 .316-.187c.129 0 .25.07.316.18ZM65.64 18.445c-.093.004-.12.14-.074.22.047.081.133.132.184.21.059.078.078.18.05.273a.153.153 0 0 1-.1.122.177.177 0 0 1-.11-.012.99.99 0 0 1-.469-.278.467.467 0 0 1-.082-.511.37.37 0 0 1 .313-.188c.132 0 .253.07.32.18ZM59.133 7.164c-.094.008-.121.14-.074.223.043.082.129.133.183.207.055.082.074.18.051.273a.16.16 0 0 1-.102.125.223.223 0 0 1-.113-.015.996.996 0 0 1-.469-.278.46.46 0 0 1-.082-.508.362.362 0 0 1 .313-.187c.133 0 .254.066.32.18ZM58.344 22.168l.117-.094a.312.312 0 0 0-.16-.156c-.074-.023-.172.047-.145.117a.16.16 0 0 0 .063.063l.222.164ZM61.23 12.828a.897.897 0 0 0 .34-.14.302.302 0 0 0 .117-.32.244.244 0 0 0-.113-.138.328.328 0 0 0-.347-.011.33.33 0 0 0-.176.3.338.338 0 0 0 .191.293ZM62.035 23.004a.248.248 0 0 1-.418-.059.667.667 0 0 1 .145-.25.421.421 0 0 1 .21.23Zm0 0"
    />
    <g clipPath="url(#bu)">
      <use xlinkHref="#bv" mask="url(#bw)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M64.164 18.328c.41.285.945.344 1.41.152a1.534 1.534 0 0 0-.465-1.332.94.94 0 0 0-1.312.102c-.281.402.07 1.09.555 1.016ZM62.918 23.715a.126.126 0 0 1-.027-.18.25.25 0 0 1 .175-.09.203.203 0 0 1 .118.012.175.175 0 0 1 .078.23.181.181 0 0 1-.239.063.186.186 0 0 1-.086-.234ZM63.496 21.09c-.023-.121-.168-.168-.293-.188-.121-.02-.27-.047-.316-.16a.089.089 0 0 1 0-.097c.043-.075.156-.024.242-.016.07-.004.14-.016.207-.031a.42.42 0 0 1 .418.21.225.225 0 0 1-.14.212.222.222 0 0 1-.247-.043ZM62.832 17.215c.027-.04.059-.078.086-.117a.175.175 0 0 0-.203-.082.14.14 0 0 0-.082.074.143.143 0 0 0 0 .113c.02.035.054.055.09.063a.13.13 0 0 0 .105-.036ZM62.355 19.883a.09.09 0 0 1-.078.004.088.088 0 0 1-.054-.051.216.216 0 0 1-.004-.156.27.27 0 0 1 .054-.117.195.195 0 0 1 .239-.028.233.233 0 0 1 .105.219.156.156 0 0 1-.047.113c-.035.028-.086.028-.117-.004ZM58.54 18.324c.12.485.483.875.964 1.028.379-.325.574-.813.523-1.305a.927.927 0 0 0-1.054-.774c-.477.122-.668.868-.25 1.13ZM59.094 22.121c.14-.031.11-.27-.02-.324a.529.529 0 0 0-.414.066.5.5 0 0 0 .438.344ZM64.281 22.863c.028-.039.059-.078.086-.117a.175.175 0 0 0-.203-.082.135.135 0 0 0-.082.078.133.133 0 0 0 0 .11c.02.035.05.058.09.062a.118.118 0 0 0 .105-.035Zm0 0"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M62.434 21.027c.418-.316.757-.718.992-1.183a.591.591 0 0 0 .078-.239.482.482 0 0 0-.246-.394 1.003 1.003 0 0 0-1.121.047c-.32.246-.496.633-.477 1.035 0 .219.086.434.242.59a.472.472 0 0 0 .598.039.102.102 0 0 0-.055-.078.108.108 0 0 0-.097 0ZM57.637 13.926c.504-.012.96-.285 1.218-.715a1.53 1.53 0 0 0-1.175-.785.926.926 0 0 0-.989.855c.016.489.711.832 1.059.485ZM66.902 12.96a.755.755 0 0 0 .578-.32.789.789 0 0 0-.261-.16.27.27 0 0 0-.281.075c-.086.113-.028.27.035.394l-.11-.035ZM67.227 11.352a.313.313 0 0 0 .14-.125.326.326 0 0 0 0-.184 2.688 2.688 0 0 1-.058-.5l-.532.656a.245.245 0 0 1-.047.043c-.07.04-.148-.031-.226-.039-.113-.008-.192.113-.227.223-.23.777.645.094.95-.074M63.941 20.75l.164-.184a.408.408 0 0 0-.46-.043c-.133.098-.13.348.03.399.098.031.263.043.231.137ZM64.215 13.688a.326.326 0 0 1-.156.132.58.58 0 0 1 .183-.476c.067-.074.156-.156.25-.125.067.023.102.09.156.136.106.086.305.098.32.235a.168.168 0 0 1-.136.164.48.48 0 0 1-.234-.016l-.5-.113ZM61.938 12.23c.14-.03.113-.265-.02-.324a.532.532 0 0 0-.414.067.506.506 0 0 0 .441.343Zm0 0"
    />
    <g clipPath="url(#bx)">
      <use xlinkHref="#by" mask="url(#bz)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M65.21 11.645a.197.197 0 0 0 .165.109c.07.008.14-.024.18-.082a.342.342 0 0 0-.137-.168.166.166 0 0 0-.207.023c-.023.028-.035.063-.023.102a.104.104 0 0 0 .07.074ZM66.727 14.477a.584.584 0 0 0 .492-.09l-.285-.317a.402.402 0 0 0-.157-.12.256.256 0 0 0-.183.038.225.225 0 0 0-.09.164.312.312 0 0 0 .203.301Zm0 0"
    />
    <g clipPath="url(#bA)">
      <use xlinkHref="#bB" mask="url(#bC)" />
      <use xlinkHref="#bD" mask="url(#bE)" />
      <use xlinkHref="#bF" mask="url(#bG)" />
      <use xlinkHref="#bH" mask="url(#bI)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M65.86 12.453c-.094.008-.118.14-.075.223.047.078.133.133.188.207.054.082.074.18.05.273a.165.165 0 0 1-.105.125.214.214 0 0 1-.11-.015.978.978 0 0 1-.468-.278.46.46 0 0 1-.082-.508.362.362 0 0 1 .312-.187c.133 0 .254.066.32.18ZM68.32 12.898a.223.223 0 0 0 .25-.183.306.306 0 0 0-.136-.3c-.04-.032-.102-.056-.137-.02a.14.14 0 0 0-.027.101l.015.426ZM62.016 14.242a.38.38 0 0 1-.156-.582c.171.07.324.188.43.336a.334.334 0 0 1 .038.258.324.324 0 0 1-.164.207l-.3-.117Zm0 0"
    />
    <g clipPath="url(#bJ)">
      <use xlinkHref="#bK" mask="url(#bL)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="M60.934 22.656a.972.972 0 0 0 .34-.144.31.31 0 0 0 .12-.32.28.28 0 0 0-.113-.137.336.336 0 0 0-.351-.012.345.345 0 0 0-.176.3.338.338 0 0 0 .191.294ZM58.953 15.703l.164-.187a.392.392 0 0 0-.137-.13.233.233 0 0 0-.093.313ZM56.965 27.723a.13.13 0 0 1-.13-.125.239.239 0 0 1 .087-.176.247.247 0 0 1 .101-.063.171.171 0 0 1 .2.137.181.181 0 0 1-.153.195.195.195 0 0 1-.207-.144ZM60.977 15.277l.164-.183a.392.392 0 0 0-.137-.13.227.227 0 0 0-.094.313ZM66.273 19.582c.09.02.157-.098.137-.191a2.098 2.098 0 0 0-.113-.254.322.322 0 0 1 .031-.274.169.169 0 0 1 .137-.09c.035.008.07.024.101.047.157.098.282.239.364.403a.465.465 0 0 1-.07.511.366.366 0 0 1-.36.086.353.353 0 0 1-.25-.265ZM61.363 20.375a.53.53 0 0 0-.203.059.17.17 0 0 0-.086.175c.024.114.176.141.254.23.074.087.067.24.168.298a.2.2 0 0 0 .164-.012.192.192 0 0 0 .098-.129.48.48 0 0 0-.059-.328.56.56 0 0 0-.176-.246.224.224 0 0 0-.28.015ZM64.914 16.352c-.25.343-.414.742-.48 1.16a.446.446 0 0 0 0 .203.394.394 0 0 0 .289.246.812.812 0 0 0 .859-.309.998.998 0 0 0 .113-.918.687.687 0 0 0-.332-.398.381.381 0 0 0-.476.113.086.086 0 0 0 .062.047.086.086 0 0 0 .074-.023ZM66.742 18.82c.051.04.113.059.18.059a.324.324 0 0 0 .156-.094c.125-.11.266-.21.41-.297l-.84-.129a.384.384 0 0 1-.062-.02c-.066-.042-.047-.144-.078-.214-.047-.102-.195-.11-.305-.082-.797.184.238.598.54.777"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#e5f6ff',
        fillOpacity: 1,
      }}
      d="m65.012 16.383.125-.074a.174.174 0 0 0-.153-.157.133.133 0 0 0-.105.04.126.126 0 0 0-.047.101c.004.035.027.07.059.09.03.02.074.023.109.012ZM67.008 17.512a.23.23 0 0 0 .285.125.315.315 0 0 0 .195-.27c.008-.05-.004-.113-.054-.129a.144.144 0 0 0-.098.028l-.367.226ZM65.879 16.465a.74.74 0 0 0 .57.332.78.78 0 0 0 .004-.3.258.258 0 0 0-.203-.208c-.137-.016-.246.113-.328.227l-.02-.114ZM65.566 15.48a.327.327 0 0 1-.195-.066.587.587 0 0 1 .508-.078c.101.016.215.055.234.152.016.067-.027.133-.039.2-.027.136.063.312-.05.394a.173.173 0 0 1-.212-.035.587.587 0 0 1-.101-.211c-.047-.16-.098-.324-.148-.488ZM66.125 18.031a.572.572 0 0 0 .324.38l.133-.403a.354.354 0 0 0 .027-.192.234.234 0 0 0-.125-.14.24.24 0 0 0-.187.004.315.315 0 0 0-.16.324ZM67.465 16.285c-.055-.078-.184-.035-.23.043a2.124 2.124 0 0 0-.09.266.352.352 0 0 1-.215.18.17.17 0 0 1-.16-.028.211.211 0 0 1-.043-.101.987.987 0 0 1 .011-.543.471.471 0 0 1 .407-.329.363.363 0 0 1 .32.547ZM61.664 17.992c.082.094.18.168.293.219a.31.31 0 0 0 .34-.055.29.29 0 0 0 .066-.168.336.336 0 0 0-.168-.304.346.346 0 0 0-.347 0 .335.335 0 0 0-.164.308ZM63.324 20.156c.13.192.34.317.57.332a.798.798 0 0 0 .008-.304.27.27 0 0 0-.203-.204c-.14-.02-.25.11-.332.227l-.02-.113ZM65.625 15.05c.027-.116-.086-.222-.191-.288-.11-.067-.23-.149-.23-.274 0-.031.01-.066.038-.086.074-.05.156.04.235.078a.887.887 0 0 0 .199.055c.164.05.281.192.297.36a.226.226 0 0 1-.211.136.222.222 0 0 1-.211-.136ZM58.031 20.867l.055-.133a.178.178 0 0 0-.215-.035.132.132 0 0 0-.062.094c-.008.039 0 .078.023.11a.125.125 0 0 0 .102.038.13.13 0 0 0 .097-.058ZM64.953 18.074l.14.055a.304.304 0 0 0 .055-.215c-.015-.078-.125-.129-.171-.066a.158.158 0 0 0-.028.082l-.031.273Zm0 0"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M38.738 53.637a5.392 5.392 0 0 0-2.207-1.035.96.96 0 0 0-.394-.024.76.76 0 0 0-.512.52 1.558 1.558 0 0 0 .512 1.675 1.967 1.967 0 0 0 1.781.313c.336-.082.629-.297.809-.594a.732.732 0 0 0-.172-.922.164.164 0 0 0-.102.114.168.168 0 0 0 .04.148Zm0 0"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M36.242 54.047a.999.999 0 0 0-.664-.695c-.258.222-.39.558-.351.894.054.34.378.574.722.52a.436.436 0 0 0 .309-.336.452.452 0 0 0-.14-.434ZM33.547 52.707a.51.51 0 0 0-.043-.445.56.56 0 0 0-.172.117.181.181 0 0 0-.031.191c.047.086.164.094.258.09l-.055.059ZM34.145 52.867a.292.292 0 0 1 .113.082.392.392 0 0 1-.348-.047c-.062-.03-.129-.078-.12-.148.003-.043.042-.078.065-.121.04-.082.02-.215.11-.246a.118.118 0 0 1 .133.066c.02.047.027.102.023.156v.348Zm0 0"
    />
    <g clipPath="url(#bM)">
      <use xlinkHref="#bN" mask="url(#bO)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M25.133 53.23a.092.092 0 0 1-.067.106.18.18 0 0 1-.132-.031.123.123 0 0 1-.055-.055.104.104 0 0 1-.004-.09.116.116 0 0 1 .063-.066.133.133 0 0 1 .156.074.134.134 0 0 1-.063.156ZM32.25 53.387a.148.148 0 0 0 .113-.07.142.142 0 0 0 0-.137.243.243 0 0 0-.148.039.111.111 0 0 0-.04.133c.009.023.032.039.055.043a.079.079 0 0 0 .07-.024ZM34.45 53.238a.392.392 0 0 0 .077-.332l-.273.09a.241.241 0 0 0-.121.063c-.028.035-.035.078-.028.125.012.043.04.078.079.097a.22.22 0 0 0 .246-.039Zm0 0"
    />
    <g clipPath="url(#bP)">
      <use xlinkHref="#bQ" mask="url(#bR)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M32.938 53.207c-.02.063.054.113.12.11.06-.016.122-.036.18-.055a.218.218 0 0 1 .188.043c.031.023.05.058.047.097a.13.13 0 0 1-.04.067.704.704 0 0 1-.304.21.325.325 0 0 1-.344-.09.234.234 0 0 1-.027-.245.24.24 0 0 1 .199-.149ZM33.898 51.813a.152.152 0 0 0-.046-.208.234.234 0 0 0-.227 0c-.031.02-.059.051-.047.086a.08.08 0 0 0 .055.04l.27.113ZM30.273 50.883a.256.256 0 0 1-.132.187.265.265 0 0 1-.23.004.637.637 0 0 1 .155-.336.226.226 0 0 1 .168-.062c.063 0 .121.027.164.074l-.035.219ZM41.934 55.637a.062.062 0 0 1 .039.031.06.06 0 0 1 .007.05.152.152 0 0 1-.07.087.282.282 0 0 1-.078.035.132.132 0 0 1-.137-.09.16.16 0 0 1 .043-.16.116.116 0 0 1 .075-.04c.03 0 .054.024.058.055ZM31.738 52.656l-.027-.101a.2.2 0 0 0-.145.058c-.035.04-.015.117.036.121a.131.131 0 0 0 .054-.02l.168-.093ZM29.945 52.336a.669.669 0 0 0-.144-.2.209.209 0 0 0-.235-.03.175.175 0 0 0-.074.093.223.223 0 0 0 .043.235.226.226 0 0 0 .23.07.228.228 0 0 0 .169-.172ZM29.504 51.578l-.149-.082a.3.3 0 0 0-.066.113c.059.063.16.07.227.012ZM34.29 49.055a2.115 2.115 0 0 0-.977-.008.4.4 0 0 0-.149.055.31.31 0 0 0-.098.277.63.63 0 0 0 .473.523.791.791 0 0 0 .7-.183.537.537 0 0 0 .19-.352.292.292 0 0 0-.218-.304c-.016.015-.023.035-.016.058.004.02.02.04.04.047ZM34.457 55.79a.519.519 0 0 0-.3-.333.523.523 0 0 0-.067.2c-.008.07.027.14.09.171.09.04.183-.023.261-.082l-.011.078ZM33.328 55.82a.202.202 0 0 0-.105-.074.189.189 0 0 0-.121.031 2.322 2.322 0 0 1-.329.114l.52.25a.081.081 0 0 1 .039.023c.035.043 0 .102.008.156.012.075.105.11.183.114.555.035-.035-.438-.195-.614M35.5 55.68a.377.377 0 0 0-.137-.313l-.168.235a.284.284 0 0 0-.054.12c0 .048.02.087.05.118.036.027.079.039.125.035.09-.02.157-.09.168-.18ZM41.035 57.32l-.094.024a.118.118 0 0 0 .067.133.107.107 0 0 0 .078-.004.095.095 0 0 0 .05-.059.08.08 0 0 0-.019-.07.078.078 0 0 0-.07-.028ZM34.2 54.867a.149.149 0 0 0-.16-.137.22.22 0 0 0-.185.133c-.011.032-.015.078.012.098a.108.108 0 0 0 .07 0l.286-.074ZM35.074 53.805a.556.556 0 0 0-.144-.2.214.214 0 0 0-.235-.03.188.188 0 0 0-.074.097.235.235 0 0 0 .043.234c.059.063.148.09.234.067a.228.228 0 0 0 .168-.172ZM31.898 51.031c-.085.008-.128.102-.152.184-.023.078-.055.176-.137.2a.072.072 0 0 1-.062-.009c-.05-.035-.008-.11.004-.168a.425.425 0 0 0-.004-.14c0-.114.07-.22.18-.262a.16.16 0 0 1 .132.11c.02.058 0 .12-.047.163Zm0 0"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M29.918 51.73c-.086.008-.129.102-.152.184-.024.078-.055.176-.133.2-.024.007-.047.007-.067-.009-.046-.035-.003-.105.008-.167a.567.567 0 0 0-.008-.141c0-.113.07-.219.18-.262a.16.16 0 0 1 .133.11c.02.058 0 .12-.047.164ZM28.547 50.969a.446.446 0 0 0-.188-.078.043.043 0 0 0-.03 0 .054.054 0 0 0-.044.043.128.128 0 0 0 .047.14c.043.031.102.04.152.02a.107.107 0 0 0 .067-.051.067.067 0 0 0-.02-.078c-.004.004-.008.008-.008.012 0 .003 0 .007.004.011ZM37.754 54.848a.515.515 0 0 0-.305-.332.523.523 0 0 0-.066.199.177.177 0 0 0 .094.172c.086.039.183-.024.257-.082-.004.027-.004.05-.007.078ZM37.125 56.164a.139.139 0 0 0 .047-.125.127.127 0 0 0-.082-.105.252.252 0 0 0-.094.117.119.119 0 0 0 .047.133c.023.011.05.011.074 0a.088.088 0 0 0 .04-.059ZM35.34 54.277a.132.132 0 0 0 .05-.125.142.142 0 0 0-.081-.109.252.252 0 0 0-.094.117.117.117 0 0 0 .047.133c.023.012.05.012.07 0a.075.075 0 0 0 .043-.059ZM37.57 55.613c.016.063.11.059.16.016.047-.043.067-.106.11-.152a.22.22 0 0 1 .176-.075.105.105 0 0 1 .097.047.1.1 0 0 1 .008.074.649.649 0 0 1-.113.352.32.32 0 0 1-.328.133.242.242 0 0 1-.176-.18.239.239 0 0 1 .074-.238ZM31.305 51.652c.015.063.11.059.16.016.047-.043.066-.105.11-.152a.249.249 0 0 1 .175-.075c.04 0 .078.016.098.051a.097.097 0 0 1 .007.074.67.67 0 0 1-.113.352.318.318 0 0 1-.328.129.236.236 0 0 1-.176-.18.241.241 0 0 1 .075-.238ZM31.633 50.898c.02.063.113.059.16.016s.07-.105.113-.152a.242.242 0 0 1 .176-.075c.04-.003.074.016.098.051.008.024.011.047.008.075a.675.675 0 0 1-.118.351.315.315 0 0 1-.328.129.248.248 0 0 1-.176-.18.25.25 0 0 1 .075-.238ZM32.672 51.637c.02.058.113.058.16.015.047-.043.07-.109.113-.156a.242.242 0 0 1 .176-.074c.04 0 .074.016.098.05.008.024.011.048.008.075a.675.675 0 0 1-.118.351.325.325 0 0 1-.328.133.244.244 0 0 1-.102-.418ZM26.09 57.633c.02.058.113.058.16.015.047-.043.07-.109.113-.156a.242.242 0 0 1 .176-.074c.04 0 .074.016.098.05.008.024.011.048.008.075a.675.675 0 0 1-.118.352.325.325 0 0 1-.328.132.262.262 0 0 1-.176-.18.244.244 0 0 1 .075-.238ZM36.273 55.883l-.082-.063a.238.238 0 0 0-.082.13c0 .05.059.105.102.077a.149.149 0 0 0 .035-.05l.074-.172ZM29.574 55.39a.607.607 0 0 0-.144-.199.208.208 0 0 0-.235-.03.175.175 0 0 0-.074.093.223.223 0 0 0 .043.234.226.226 0 0 0 .23.07.223.223 0 0 0 .169-.171ZM36.277 53.324c.051.024.086.078.09.137a.162.162 0 0 1-.07.148.525.525 0 0 1-.188-.058.314.314 0 0 1 .125-.176Zm0 0"
    />
    <g clipPath="url(#bS)">
      <use xlinkHref="#bT" mask="url(#bU)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M32.816 52.625a.974.974 0 0 0-.109-.95c-.34.028-.648.216-.82.509a.626.626 0 0 0 .265.847c.309.125.72-.21.598-.52ZM36.621 52.637c-.02.043-.07.062-.117.043a.159.159 0 0 1-.086-.102c-.012-.023-.016-.05-.012-.078a.118.118 0 0 1 .055-.074.131.131 0 0 1 .086-.016.126.126 0 0 1 .082.149.129.129 0 0 1-.145.09ZM34.773 52.648c-.078.036-.09.141-.086.223.008.086.012.184-.058.234a.082.082 0 0 1-.066.016c-.055-.02-.04-.101-.047-.16-.012-.047-.032-.09-.051-.133a.278.278 0 0 1 .078-.305.157.157 0 0 1 .164.059.16.16 0 0 1 .008.172ZM32.27 53.672l-.09-.035a.118.118 0 0 0-.024.144c.012.02.035.035.063.043.027.004.054 0 .074-.015a.085.085 0 0 0 .031-.07.096.096 0 0 0-.043-.067ZM34.133 53.586c.012.012.02.031.015.047a.072.072 0 0 1-.027.047.163.163 0 0 1-.105.023.168.168 0 0 1-.086-.016.134.134 0 0 1-.055-.152.167.167 0 0 1 .133-.105.102.102 0 0 1 .082.015.06.06 0 0 1 .015.078ZM33.664 56.336a.982.982 0 0 0 .543-.79 1.052 1.052 0 0 0-.953-.151.657.657 0 0 0-.352.335.621.621 0 0 0-.007.48.46.46 0 0 0 .398.227c.164 0 .316-.09.395-.234ZM36.125 55.398c-.04-.09-.195-.035-.21.063a.35.35 0 0 0 .105.262.34.34 0 0 0 .164-.344ZM35.844 51.863l-.09-.039c-.043.04-.055.098-.027.145.015.023.039.039.062.047a.135.135 0 0 0 .078-.016c.02-.02.031-.047.028-.07a.091.091 0 0 0-.04-.067Zm0 0"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M34.89 53.363a2.282 2.282 0 0 0-.945-.476.353.353 0 0 0-.168-.016.34.34 0 0 0-.23.219.678.678 0 0 0 .2.734c.214.172.503.23.769.156a.572.572 0 0 0 .359-.246.317.317 0 0 0-.066-.402c-.02.008-.04.027-.043.047-.008.023 0 .047.015.066ZM30.852 57.598a.984.984 0 0 0-.665-.696 1.032 1.032 0 0 0-.351.891.633.633 0 0 0 .727.523.462.462 0 0 0 .308-.336.452.452 0 0 0-.144-.433ZM28.805 51.633a.506.506 0 0 0-.305-.332.484.484 0 0 0-.066.195c-.008.07.03.14.093.176.086.039.184-.024.258-.086-.004.027-.004.055-.008.078ZM27.676 51.66a.202.202 0 0 0-.106-.074.214.214 0 0 0-.12.027 1.63 1.63 0 0 1-.329.114l.52.253a.081.081 0 0 1 .039.024c.035.043 0 .101.008.156.011.074.105.11.183.113.555.036-.035-.437-.195-.613M34.477 52.41l-.149-.082a.26.26 0 0 0 .043.309c.082.074.25.031.262-.078.004-.07-.012-.18.054-.172ZM29.695 53.293a.22.22 0 0 1 .114.082.394.394 0 0 1-.348-.047c-.059-.031-.129-.078-.121-.148.004-.043.047-.078.066-.121.043-.082.024-.215.114-.246a.116.116 0 0 1 .128.066.3.3 0 0 1 .024.156v.348ZM29.063 55.016c-.04-.09-.196-.036-.211.062a.345.345 0 0 0 .105.262.334.334 0 0 0 .164-.34Zm0 0"
    />
    <g clipPath="url(#bV)">
      <use xlinkHref="#bW" mask="url(#bX)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M28.176 52.945a.143.143 0 0 0 .05-.125.139.139 0 0 0-.085-.105.223.223 0 0 0-.09.117c-.02.05 0 .105.047.133.02.012.047.012.07 0a.088.088 0 0 0 .039-.059ZM29.848 51.52a.393.393 0 0 0-.137-.31l-.168.235a.235.235 0 0 0-.059.121.174.174 0 0 0 .055.114.154.154 0 0 0 .121.035c.09-.02.16-.09.172-.18Zm0 0"
    />
    <g clipPath="url(#bY)">
      <use xlinkHref="#bZ" mask="url(#ca)" />
      <use xlinkHref="#cb" mask="url(#cc)" />
      <use xlinkHref="#cd" mask="url(#ce)" />
      <use xlinkHref="#cf" mask="url(#cg)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M28.621 52.395c.02.062.113.058.16.015.047-.043.07-.105.114-.152a.235.235 0 0 1 .175-.074c.04 0 .075.015.098.05.008.024.012.047.008.075a.711.711 0 0 1-.117.351.318.318 0 0 1-.329.13.236.236 0 0 1-.175-.18.25.25 0 0 1 .074-.239ZM28.547 50.707a.153.153 0 0 0-.164-.137.217.217 0 0 0-.18.137c-.015.031-.02.074.012.094.02.008.047.008.07 0l.285-.074ZM30.402 54.66a.264.264 0 0 1-.367.192.643.643 0 0 1 .16-.336.24.24 0 0 1 .168-.067.226.226 0 0 1 .16.078l-.03.215Zm0 0"
    />
    <g clipPath="url(#ch)">
      <use xlinkHref="#ci" mask="url(#cj)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M36.207 54.102a.607.607 0 0 0-.145-.2.208.208 0 0 0-.234-.03.175.175 0 0 0-.074.093.223.223 0 0 0 .043.234.226.226 0 0 0 .23.07.228.228 0 0 0 .168-.171ZM31.844 56.457l-.149-.078a.267.267 0 0 0-.066.11.16.16 0 0 0 .223.015ZM40.207 55.953a.089.089 0 0 1-.066.106.166.166 0 0 1-.13-.032.157.157 0 0 1-.058-.054.12.12 0 0 1 0-.09.106.106 0 0 1 .063-.067c.062-.015.129.012.152.075a.13.13 0 0 1-.063.156ZM31.254 55.188l-.149-.079a.267.267 0 0 0-.066.11.16.16 0 0 0 .223.015ZM33.34 51.047c0-.063-.09-.09-.149-.063a2.2 2.2 0 0 0-.152.114.221.221 0 0 1-.191.02.107.107 0 0 1-.078-.075.17.17 0 0 1 .015-.074.69.69 0 0 1 .215-.301.314.314 0 0 1 .352-.031.235.235 0 0 1 .113.222.242.242 0 0 1-.14.207ZM34.613 54.164c.016.047.04.086.07.125a.129.129 0 0 0 .133.031c.07-.035.067-.136.114-.203.05-.062.148-.082.175-.156.024-.07-.054-.148-.132-.152a.316.316 0 0 0-.211.09.342.342 0 0 0-.137.152.146.146 0 0 0 .05.183ZM31.379 52.434c.27.109.558.156.851.136a.33.33 0 0 0 .137-.027.278.278 0 0 0 .121-.227.55.55 0 0 0-.336-.52.698.698 0 0 0-.632.063.462.462 0 0 0-.22.282.263.263 0 0 0 .15.297.063.063 0 0 0 .023-.051.048.048 0 0 0-.028-.043ZM32.758 50.852a.226.226 0 0 0 .012-.125.236.236 0 0 0-.086-.09 2.023 2.023 0 0 1-.262-.223c.012.188.027.379.039.57a.096.096 0 0 1-.004.047c-.016.047-.09.051-.129.082-.062.047-.043.145-.012.215.246.496.368-.25.442-.473"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="m31.383 52.36-.067-.067a.114.114 0 0 0-.082.121c.004.027.02.05.043.066.02.012.047.02.075.012a.088.088 0 0 0 .054-.05.082.082 0 0 0-.011-.075ZM31.84 50.875a.15.15 0 0 0 .039-.207.22.22 0 0 0-.211-.09c-.031.004-.074.02-.078.055a.101.101 0 0 0 .035.062l.207.207ZM31.309 51.777c.109-.113.16-.27.136-.425-.07 0-.14.015-.203.043a.17.17 0 0 0-.105.164c.008.093.11.148.199.183l-.074.031ZM30.695 52.133a.21.21 0 0 1-.015.137.393.393 0 0 1-.13-.325c-.003-.066.005-.148.067-.175.043-.02.094 0 .14-.004.095-.004.2-.09.27-.028.04.04.043.102.008.145a.327.327 0 0 1-.12.097l-.31.172ZM32.324 51.379a.396.396 0 0 0 .203-.27l-.289-.027a.221.221 0 0 0-.133.008.152.152 0 0 0-.043.227c.063.07.157.09.243.058ZM30.95 50.758c-.044.047.003.129.062.148.066.008.129.016.191.02a.216.216 0 0 1 .152.113.11.11 0 0 1 .008.11.139.139 0 0 1-.062.042.696.696 0 0 1-.363.079.326.326 0 0 1-.282-.22.254.254 0 0 1 .07-.237.248.248 0 0 1 .247-.055ZM32.969 54.324a.603.603 0 0 0 .105-.226.212.212 0 0 0-.09-.215.188.188 0 0 0-.12-.016.224.224 0 0 0-.18.156.222.222 0 0 0 .054.23.237.237 0 0 0 .23.06ZM34.168 52.902a.49.49 0 0 0 .14-.425c-.07 0-.14.015-.203.043a.179.179 0 0 0-.109.164c.012.093.113.148.203.183l-.074.031ZM30.398 52.16c-.082 0-.136.09-.164.168-.027.078-.066.172-.148.192a.068.068 0 0 1-.066-.012c-.043-.043.003-.11.02-.164.007-.047.007-.094.007-.14a.276.276 0 0 1 .195-.255.16.16 0 0 1 .125.121.163.163 0 0 1-.062.16ZM35.445 56.285l-.093-.015a.113.113 0 0 0 .007.148c.02.02.043.027.07.027a.091.091 0 0 0 .071-.03.086.086 0 0 0 .012-.075.077.077 0 0 0-.055-.055ZM32.527 52.145l.02-.102a.238.238 0 0 0-.156-.004c-.047.023-.063.102-.016.125a.1.1 0 0 0 .059.004l.187-.02Zm0 0"
    />
    <g clipPath="url(#ck)">
      <use xlinkHref="#cl" mask="url(#cm)" />
    </g>
    <g clipPath="url(#cn)">
      <g clipPath="url(#co)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#cp)',
          }}
          d="M53.797 14.555 54.863-.31l11.242.797-1.07 14.86Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#cq)">
      <g clipPath="url(#cr)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#cs)',
          }}
          d="m19.41 66.785 1.742-13.758 9.633 1.2-1.746 13.757Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#ct)">
      <g clipPath="url(#cu)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#cv)',
          }}
          d="m30.078 67.926 1.996-15.754 9.922 1.234L40 69.16Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#cw)">
      <g clipPath="url(#cx)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#cy)',
          }}
          d="M20.387 53.988h8.75v5.606h-8.75Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#cz)">
      <g clipPath="url(#cA)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#cB)',
          }}
          d="M31.754 53.215h8.273v5.91h-8.273Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#cC)">
      <use xlinkHref="#cD" mask="url(#cE)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M35.855 60.285c-.289.09-.355 2.383.13 2.512.48.129.542-2.719-.13-2.512"
    />
    <g clipPath="url(#cF)">
      <use xlinkHref="#cG" mask="url(#cH)" />
    </g>
    <g clipPath="url(#cI)">
      <g clipPath="url(#cJ)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#cK)',
          }}
          d="m10.188 55.05 2.617-20.66 12.718 1.583-2.617 20.66Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#cL)">
      <g clipPath="url(#cM)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#cN)',
          }}
          d="M12.664 52.121h5.578v4.102h-5.578Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#cO)">
      <use xlinkHref="#cP" mask="url(#cQ)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M18.508 45.047c-.332-.125 1.383-3.973 1.914-4.008.531-.035-1.629 4.113-1.914 4.008M18.336 45.457c-.262-.137-.512.582-.27.688.239.105.567-.532.27-.688"
    />
    <g clipPath="url(#cR)">
      <g clipPath="url(#cS)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#cT)',
          }}
          d="M10.848 64.184 12.352 52.3l7.3.91-1.504 11.883Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#cU)">
      <g clipPath="url(#cV)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#cW)',
          }}
          d="M14.18 54.18h4.222v9.89H14.18Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#cX)">
      <use xlinkHref="#cY" mask="url(#cZ)" />
    </g>
    <g clipPath="url(#da)">
      <g clipPath="url(#db)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#dc)',
          }}
          d="m14.809 61.336.93-7.367 3.972.496-.93 7.363Zm0 0"
        />
      </g>
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M16.484 56.383c-.472 0 .246 2.066.489 2.015.246-.046-.098-2.015-.489-2.015"
    />
    <g clipPath="url(#dd)">
      <g clipPath="url(#de)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#df)',
          }}
          d="M14.457 7.05h7.379v11.704h-7.379Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#dg)">
      <g clipPath="url(#dh)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#di)',
          }}
          d="M16.09 7.05h3.152v7.282H16.09Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#dj)">
      <g clipPath="url(#dk)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#dl)',
          }}
          d="M39.457 7.05h7.379v11.704h-7.379Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#dm)">
      <g clipPath="url(#dn)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#do)',
          }}
          d="M42.086 7.047h3.187v6.363h-3.187Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#dp)">
      <g clipPath="url(#dq)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#dr)',
          }}
          d="M42.262 7.813h6.273v11.5h-6.273Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#ds)">
      <g clipPath="url(#dt)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#du)',
          }}
          d="M12.758 7.813h6.273v11.5h-6.273Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#dv)">
      <g clipPath="url(#dw)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#dx)',
          }}
          d="m9.867 36.332 4.43-34.988 37.039 4.61-4.434 34.991Zm0 0"
        />
      </g>
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#dfe3fb',
        fillOpacity: 1,
      }}
      d="M17.34 24.086c1.062 4.5 20.691 4.988 25.515.914 4.82-4.078-2.125-18.566-12.757-17.93-9.73.578-14.5 9.649-12.758 17.016"
    />
    <g clipPath="url(#dy)">
      <g clipPath="url(#dz)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#dA)',
          }}
          d="M15.496 6.504H47.47V28.53H15.496Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#dB)">
      <use xlinkHref="#dC" mask="url(#dD)" />
    </g>
    <g clipPath="url(#dE)">
      <g clipPath="url(#dF)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#dG)',
          }}
          d="M18.617 30.496h23.711v4.586h-23.71Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#dH)">
      <use xlinkHref="#dI" mask="url(#dJ)" />
    </g>
    <g clipPath="url(#dK)">
      <g clipPath="url(#dL)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#dM)',
          }}
          d="m20.785 33.023.61-4.828 18.793 2.34-.614 4.828Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#dN)">
      <g clipPath="url(#dO)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#dP)',
          }}
          d="m17.484 57.895 3.543-27.95 22.32 2.778-3.542 27.949Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#dQ)">
      <g clipPath="url(#dR)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#dS)',
          }}
          d="M36.172 34.738h3.09v7.25h-3.09Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#dT)">
      <g clipPath="url(#dU)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#dV)',
          }}
          d="m34.008 40.031 2.133-16.84 17.07 2.125-2.133 16.84Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#dW)">
      <use xlinkHref="#dX" mask="url(#dY)" />
    </g>
    <g clipPath="url(#dZ)">
      <g clipPath="url(#ea)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#eb)',
          }}
          d="M47.68 25.012h3.586v6.187H47.68Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#ec)">
      <g clipPath="url(#ed)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#ee)',
          }}
          d="M33.871 11.848h6.356v5.648H33.87Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#ef)">
      <g clipPath="url(#eg)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#eh)',
          }}
          d="M20.86 11.848h6.355v5.648h-6.356Zm0 0"
        />
      </g>
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#2f95cd',
        fillOpacity: 1,
      }}
      d="M25.563 18.543s1.34 1.371 5.136 1.371c3.801 0 5.746-1.582 5.746-1.582s-1.672 2.25-5.746 2.25c-4.07 0-5.137-2.039-5.137-2.039"
    />
    <g clipPath="url(#ei)">
      <g clipPath="url(#ej)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#ek)',
          }}
          d="M4.598 28.434 6.555 12.98l12.66 1.575-1.961 15.453Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#el)">
      <g clipPath="url(#em)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#en)',
          }}
          d="m14.36 27.879 1.21-5.094 7.953 1.856-1.21 5.093Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#eo)">
      <use xlinkHref="#ep" mask="url(#eq)" />
      <use xlinkHref="#er" mask="url(#es)" />
      <use xlinkHref="#et" mask="url(#eu)" />
      <use xlinkHref="#ev" mask="url(#ew)" />
    </g>
    <g clipPath="url(#ex)">
      <g clipPath="url(#ey)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#ez)',
          }}
          d="M21.18 41.566h17.703v16.309H21.18Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#eA)">
      <g clipPath="url(#eB)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#eC)',
          }}
          d="M21.227 41.988H38.93v16.309H21.227Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#eD)">
      <use xlinkHref="#eE" mask="url(#eF)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M34.398 37.86c-.265.09-.28 2.23 0 2.574.282.347.73.238.883-.266.149-.504-.476-2.441-.883-2.309M34.895 41.004c-.223.055-.25.586-.145.77.07.09.184.132.297.113a.329.329 0 0 0 .258-.192c.062-.226-.184-.742-.41-.691"
    />
    <g clipPath="url(#eG)">
      <use xlinkHref="#eH" mask="url(#eI)" />
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M34.07 6.398c-.472.11 3.477 2.18 3.637 1.934.156-.246-2.336-2.234-3.637-1.934M41.633 7.945c-.395.211-.363.633.453.528.812-.106 1.258-.739 1.168-.86-.09-.125-1.18.098-1.621.332"
    />
    <g clipPath="url(#eJ)">
      <use xlinkHref="#eK" mask="url(#eL)" />
    </g>
    <g clipPath="url(#eM)">
      <g clipPath="url(#eN)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#eO)',
          }}
          d="m46.61 29.73 1.632-12.87 8.672 1.081-1.633 12.868Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#eP)">
      <g clipPath="url(#eQ)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#eR)',
          }}
          d="M48.242 17.75h4.602v7.953h-4.602Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#eS)">
      <use xlinkHref="#eT" mask="url(#eU)" />
    </g>
    <g clipPath="url(#eV)">
      <g clipPath="url(#eW)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#eX)',
          }}
          d="m46.832 25.105.875-6.918 3.383.418-.875 6.922Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#eY)">
      <g clipPath="url(#eZ)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#fa)',
          }}
          d="M50.36 22.047h3.3v4.41h-3.3Zm0 0"
        />
      </g>
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M48.8 20.09c-.21-.024-.14 1.844.126 1.765.265-.078.18-1.73-.125-1.765"
    />
    <g clipPath="url(#fb)">
      <g clipPath="url(#fc)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#fd)',
          }}
          d="M16.043 24.547h5.855v1.785h-5.855Zm0 0"
        />
      </g>
    </g>
    <g clipPath="url(#fe)">
      <use xlinkHref="#ff" mask="url(#fg)" />
      <use xlinkHref="#fh" mask="url(#fi)" />
    </g>
    <g clipPath="url(#fj)">
      <g clipPath="url(#fk)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#fl)',
          }}
          d="M50.36 14.55 51.468-.882l13.668.965-1.106 15.434Zm0 0"
        />
      </g>
    </g>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M55.988 3.96a85.42 85.42 0 0 0-.093 2.759c.058.004.117.008.18.008h.179c.074 0 .152 0 .23-.004l.243-.012c.003-.106.003-.207.003-.305v-.308c0-.356-.003-.711-.007-1.067-.008-.355-.02-.71-.035-1.07h.87a49.775 49.775 0 0 0-.097 1.684 40.275 40.275 0 0 0-.031 1.687c0 .277.004.55.008.828.007.274.019.55.03.828h-.808c.012-.277.02-.554.031-.836.008-.277.02-.554.028-.832-.137-.004-.27-.011-.403-.015a6.783 6.783 0 0 0-.398-.012h-.031v1.215c0 .156.004.32.008.48h-.813c.012-.336.02-.672.023-1.004.004-.332.004-.66.004-.992 0-1.012-.02-2.023-.062-3.035ZM59.387 8.969l-.285-.012c-.094 0-.188-.004-.286-.004-.156 0-.312.004-.468.012a9.411 9.411 0 0 0-.47.023l.009-.758c.054.008.11.016.164.02l.164.012c.015-.364.027-.727.043-1.09.012-.36.02-.719.02-1.082 0-.242-.005-.48-.012-.715l-.024-.715c-.058 0-.12 0-.187.004l-.196.012.008-.739c.184.012.363.024.547.028.184.008.367.008.55.008h.2c.066 0 .137 0 .203-.008l-.02.703c-.054 0-.109 0-.163-.004-.051-.004-.106-.004-.16-.004-.036.422-.06.844-.07 1.262a33.46 33.46 0 0 0-.024 1.258c0 .367.008.734.023 1.101.074 0 .152 0 .23-.004.083 0 .16-.004.243-.011ZM60.54 8.723c0 .054-.013.109-.036.156a.382.382 0 0 1-.09.129.37.37 0 0 1-.133.086.382.382 0 0 1-.316 0 .37.37 0 0 1-.133-.086.373.373 0 0 1-.086-.13.304.304 0 0 1-.031-.155.304.304 0 0 1 .031-.157c.02-.05.05-.093.086-.129a.413.413 0 0 1 .672.129.352.352 0 0 1 .035.157m.063-4.813a46.646 46.646 0 0 0-.157 1.969c-.039.664-.062 1.316-.066 1.957l-.473.012c-.02-.645-.039-1.301-.066-1.965-.028-.664-.059-1.317-.094-1.965Zm0 0"
    />
    <g clipPath="url(#fm)">
      <use xlinkHref="#fn" mask="url(#fo)" />
      <use xlinkHref="#fp" mask="url(#fq)" />
    </g>
    <g clipPath="url(#fr)">
      <g clipPath="url(#fs)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'url(#ft)',
          }}
          d="m10.074 18.98.07-4.043 3.387.055-.066 4.043Zm0 0"
        />
      </g>
    </g>
  </svg>
)

export default RobotIcon
